const PORTUGUESE_TRANSLATION = {
  home: {
    confront: {
      title: `CONFRONTE SEUS DADOS`,
      title_2: "E VEJA-OS EM UM DASHBOARD",
      section_text_1:
        "Analisar e gerenciar todos os dados e regras de negócio da sua empresa parece impossível? Dashboards inteligentes são soluções simples e assertivas.",
      section_text_2:
        "14 dias de avaliação gratuita. Não precisa de cartão de crédito.",
    },
    business_assurance_section: {
      title: `SOMOS UMA PLATAFORMA DE BUSINESS ASSURANCE`,
      section_text: `Conecte qualquer tipo de fonte de dados em um único Data Source e crie dashboards atrativos e interativos, onde você pode compartilhar automaticamente com seus colaboradores, fornecedores e clientes. Assista ao nosso vídeo e saiba mais sobre a Hyaia e o que podemos fazer.`,
    },
    who_we_are: {
      title: "QUEM SOMOS",
      section_text_1: `Somos uma empresa com foco em recuperação e garantia de receita através de consultoria e tecnologia, visamos proporcionar ao cliente um aumento da eficiência financeira e operacional nos negócios, além de identificar e tratar as possíveis irregularidades (fraudes e perdas).`,
      section_text_2: `Com atendimento personalizado aos nossos clientes, nos tornamos referência nas áreas de telecomunicações, varejo, indústria e saúde. Contamos com uma equipe qualificada e apta para identificar as demandas e prover os melhores resultados para seu negócio, utilizando uma tecnologia única e com alto grau de processamento.`,
      section_text_3: `Atualmente, estamos presentes na vida de milhares de pessoas. Auxiliamos nossos clientes em sua jornada à evolução digital, por meio de consultoria ou desenvolvimento de soluções, prestando serviços com qualidade e comprometimento.`,
    },
    hyaia_gathers: {
      title: `A HYAIA REÚNE, EM UM SÓ PRODUTO, FERRAMENTAS QUE DISPONIBILIZAM RECURSOS FLEXÍVEIS E GARANTEM AUTONOMIA À ÁREA DE NEGÓCIO`,
    },
    for_whom: {
      business_man: {
        title: "PARA EMPRESÁRIOS",
        section_text: "Melhor qualidade de dados para tomada de decisões",
      },
      business_architects: {
        title: "PARA ARQUITETOS DE NEGÓCIO",
        section_text: "Revolução em BA & BI integrados",
      },
      consultants: {
        title: "PARA CONSULTORES",
        section_text: "Aumente sua oferta de serviços",
      },
    },
    differential: {
      title: "QUAL O NOSSO DIFERENCIAL?",
      section_text:
        "A Hyaia descomplica o Business Revenue Assurance de qualquer negócio ou tipo de empresa. Nossa tecnologia ágil e inovadora permite uma visão completa de tudo o que acontece nas cadeias operacionais e financeiras de seus empreendimentos. Isso permite uma análise melhor, mais rápida e inteligente para tomada de decisões, mantendo o Data Lake como único ponto de verdade.",
    },
    how_it_works: {
      title: "COMO FUNCIONA?",
    },
    step1: {
      title: "FÁCIL CONEXÃO DE DADOS",
      section_text:
        "Conexão simples com qualquer base de dados, independente do formato.",
    },

    step2: {
      title: "APLICAÇÃO E PROCESSAMENTO DAS REGRAS DE NEGÓCIO",
      section_text:
        "Uma vez conectada todas as politicas operacionais, financeiras, estratégias e regras de negócio são inseridas na plataforma e as mesmas são aplicadas na base de dados.",
    },

    step3: {
      title: "RESULTADO EM DASHBOARDS & WORKFLOWS",
      section_text:
        "Toda irregularidade, perda financeira, exposição ao risco, performance são apresentadas em dashboards e workflows.",
    },

    step4: {
      title: "ANÁLISE DOS DADOS E TOMADAS DE DECISÃO",
      section_text:
        "Com resultados oferecidos em real time ou near real time, suas decisões serão mais precisas e assertivas, aumentando seus lucros.",
    },

    customer_testimonials: {
      title: "GRANDES CLIENTES PELO MUNDO",
      section_text:
        "Veja o que nossos clientes pensam sobre a atuação da Hyaia em seus negócios",
    },

    lets_start: {
      title: "VAMOS COMEÇAR?",
      section_text: `Comece a acompanhar seu negócio de ponta a ponta.`,
    },
  },
  suport: {
    title: "DESENVOLVA & INTEGRE",
    section_text:
      "Aplique algoritmos de Machine Learning direto da sua base de dados. Adicione dashboards em portais e aplicativos móveis ou acrescente uma integração, em real time, a qualquer sistema externo.",
    list_api_advantages: {
      api_advantages: {
        title: "QUAIS AS VANTAGENS DE UMA API?",
        section_text:
          "Inúmeras! As APIs (Application Program Interface) possibilitam gerenciar a maioria das funções da Hyaia, através do seu próprio aplicativo.",
      },

      mobile_apps: {
        title: "DESENVOLVA APLICATIVOS MÓVEIS",
        section_text_1:
          "Quer ter seu próprio aplicativo móvel de relatórios e dashboards,com sua marca ou logotipo?",
        section_text_2:
          "Por meio de nossos Live Links e API você pode criar e mostrar seu app móvel, em todas as plataformas principais.",
        section_text_3:
          "Inclua um módulo de relatório inteiro ao seu app de celular em instantes.",
      },

      dashboards: {
        title: "DASHBOARDS INCORPORADOS",
        section_text_1:
          "Com nossos Live Links e API você pode criar e incorporar diretamente em seus apps na web.",
        section_text_2:
          "Transmita seus parâmetros e segurança, e faça interações que te levem diretamente ao aplicativo principal.",
      },
    },

    list_data: {
      realtime_data: {
        title: "DADOS EM REAL TIME",
        section_text_1:
          "No mesmo instante em que novos dados chegarem você poderá vê-los, ao mesmo tempo, em nossos dashboards através da nossa API.",
        section_text_2:
          "Nossas APIs são excelentes para monitorar novas informações, processos e regras em vendas, tickets de suporte, loT e muitos outros itens fundamentais em real time.",
      },
      data_management: {
        title: "FAÇA A GESTÃO DE SEUS DADOS",
        section_text:
          "Faça o controle de suas informações por meio de seus aplicativos através das nossas APIs. Crie um centro de controle automatizado para atualizações e adições de dados. Gerenciamento de agendas monitorando-as, acionando-as e pausando-as.",
      },
      interactive: {
        title: "DEIXE-O INTERATIVO",
        section_text:
          "Inclua filtros e análises dinâmicas para seus users manipularem dashboards e acessarem respostas para suas questões de negócios. Filtre dados por equipe ou usuário.",
      },
      process_automation: {
        title: "PROCESSOS AUTOMATIZADOS",
        section_text:
          "Programe publicações e alertas. Desenvolvemos de maneira estratégica todas as atualizações de dados e distribuição de dashboards para você.",
      },
    },

    want_know_more: {
      title: "QUER MAIS INFORMAÇÕES?            ",
      section_text:
        "Entre em contato com nosso time técnico e aprenda como autorizar, referenciar e usar nossos pontos de extremidade da API.",
    },
  },

  tickets: {
    title: "ASSISTÊNCIA ONLINE & TICKETS DE SUPORTE ",
    section_text:
      "Tenha acesso a todas as regras e processos de sua empresa com nossos recursos online.",
    resources: {
      title: "ACESSE TODOS OS NOSSOS RECURSOS",
      section_text_1:
        "Nosso time de suporte está aqui para lhe prestar todas as informações que você precisa sobre a Hyaia.",
      section_text_2:
        "Quer saber mais sobre a Hyaia? Entre em contato conosco pelos nossos canais de atendimento.",
    },

    online_support: {
      title: "ASSISTÊNCIA ONLINE",
      section_text:
        "Realizamos tudo, desde conexão de dados, preparação e transformação de informações até visualizações avançadas.",
    },

    content_faq: {
      title: "FAQ COM CONTEÚDO",
      section_text_1:
        "Sanamos suas dúvidas mais correntes no FAQ (Frequently Asked Questions) online. Você acessa rapidamente as respostas para suas perguntas específicas, como:",
      section_text_2: "'Como é realizada a conexão com a minha base de dados?'",
    },

    support_tickets: {
      title: "PROGRAMA DE TICKETS DE SUPORTE CONECTADO",
      section_text:
        "Obtenha um ticket de suporte para que nossos experts o auxiliem em suas soluções. Nosso time é recomendado por nossos clientes pela sua qualidade e suporte.",
    },
  },

  chat: {
    title: "FALE DIRETO COM NOSSOS EXPERTS",
    section_text:
      "Receba assistência de nosso time de experts em soluções, direto da sua conta com o chat de ajuda, pelo nosso site.",
    chat_expert: {
      title: "PRECISA DE UMA MÃO? CONVERSE AGORA COM UM DE NOSSOS EXPERTS",
      section_text_1:
        "Com dificuldade para desenrolar? Tentando lembrar uma regra ou processo para criar seus dashboards?",
      section_text_2:
        "Na Hyaia oferecemos a ajuda que você precisa, para visualizar ao máximo suas informações.",
    },

    need_help: {
      title: "NO LUGAR QUE VOCÊ PRECISA",
      section_text_1:
        "Com a Hyaia será possível: aprender uma nova solução, criar regras e processos e se tornar especialista em dados fidedignos.",
      section_text_2:
        "Através de nosso chat integrado, você consegue imediatamente falar com nosso time de analistas de negócios e especialistas da Hyaia. Para ajudar com:",
      section_text_3: "Como começar a usar nossa plataforma.",
      section_text_4: "Visualização e conexão de dados.",
      section_text_5: "Criação de regras e processos de negócio.",
      section_text_6: "Programações de instalação e automação.",
      section_text_7: "Tira dúvidas instantâneo.",
      section_text_8: "E muito mais.",
      section_text_9:
        "Nosso chat integrado está acessível em alguns níveis de licença, e com opção para acesso às demais.",
    },

    governance: {
      title: "USUFRUA DE CADA VOLUME DE GOVERNO",
      section_text_1:
        "Nossa equipe pode lhe mostrar como obter o máximo de desempenho da nossa tecnologia sobre seus dados.",
      section_text_2: "Auxiliamos você a potencializar:",
      section_text_3: "O poder da automação.",
      section_text_4: "Gerenciamento de regras e processos.",
      section_text_5: "Dashboards e KPIs.",
      section_text_6: "E outros recursos de BRA da nossa plataforma incrível.",
    },

    customer_testimonials: {
      title:
        "SEJA ACOMPANHADO, EM TODOS OS SEUS PROCESSOS E REGRAS, PELA NOSSA EQUIPE DE SUPORTE",
      customer_testimonial_1: {
        section_text_1: "Não imaginava que seria tão fantástico assim.",
        section_text_2: "",
        section_text_3: "",
      },
      customer_testimonial_2: {
        section_text_1:
          "Antes, eu tinha que fazer várias conciliações, usar vários sistemas, pagar caro em auditorias e esperar muito tempo para ver os resultados. Quando coloquei a Hyaia, tudo o que acontecia na empresa chegava em tempo real pra mim. Parecia que estava em um outro mundo, por causa de tanta tecnologia e profissionalismo da Hyaia.",
        section_text_2: "Mike Owens",
        section_text_3: "CEO",
      },
      customer_testimonial_3: {
        section_text_1: "Aumentamos assustadoramente nossas margens de lucro.",
        section_text_2: "",
        section_text_3: "",
      },
      customer_testimonial_4: {
        section_text_1:
          "Depois que implantamos a Hyaia para confrontar nossas regras e processos de negócio. Começamos a detectar todas as fontes de perda financeira da companhia, conseguindo estancá-las de maneira cirúrgica e rápida. Recebemos até antecipações de problemas, para tomar atitudes de prevenção. Nosso lucro aumentou, a empresa está crescendo mais e nossos acionistas estão felizes.",
        section_text_2: "Louise Monreau",
        section_text_3: "CFO",
      },
    },
  },

  modules: {
    title: `CONHEÇA NOSSOS MÓDULOS`,
    subtitle_desc: `Descubra o que a melhor e única tecnologia multimercados do mundo, em Business Revenue Assurance, pode fazer por você.`,
    audit_text_1: `Audite 100% da sua base de dados e encontre toda não conformidade e perda financeira do seu negócio.`,
    audit_text_2: `Tenha relatórios precisos e fidedignos, em tempo real, para tomadas de decisões que vão solucionar as suas dores em tempo hábil.`,
    fraud_text: `Localize, em tempo real, qualquer condição de fraude em seu negócio. A Hyaia é a melhor e mais moderna em sistema antifraude. Garantindo agilidade e precisão na detecção de irregularidades.`,
    compliance_text: `A governança corporativa do seu negócio é realizada por Inteligência Artificial em tempo real. Não perca certificações ou receba multas por falta de compliance. A Hyaia é o melhor controlador que seu negócio pode ter.`,
    indicator_text_1: `Um gerador de KPI e OKRs criados a partir dos dados auditados.`,
    indicator_text_2: ` Confronte seus indicadores através dos resultados mostrados pelo INDICATOR.`,
    dashboard_text: `Seus relatórios de auditoria, fraude, discrepâncias e exposição ao risco em dashboards interativos. Com layout moderno para tomadas de decisões rápidas e cruciais.`,
    chatbot_text: `Robos interativos para um melhor acompanhamento, alertas e notificações sobre seus processos, regras e politicas corporativas.`,
    analysis_text_1: `Uma tecnologia revolucionaria em Deep Learning para tuning de processos, regras e antecipação de problemas que reduzem suas margens de lucro.`,
    analysis_text_2: `Previnir é melhor que remediar, esse módulo analisa e indica o caminho do futuro do seu negócio com um grande percentual de acerto.`,
    bigdata_text_1: `Seus dados organizados, centralizados e convertidos em informações claras e de qualidade.`,
    bigdata_text_2: `O melhor em tecnologia Big Data está na Hyaia.`,
    machine_learn_text_1: `Um módulo revolucionário em compreensão e aprendizagem do seu negócio.`,
    machine_learn_text_2: `A cada processo, regra ou política corporativa, o Machine Learning da Hyaia, aprende e memoriza o que lhe é ensinado. Sem necessidade de retreinamento ou substituição de usuário.`,
    scheduler_text_1: `Um agendador customizável para auditagem dos seus dados, sobre as suas regras e processos.`,
    scheduler_text_2: `Audite o tempo todo ou em períodos determinados, você decide o que fica melhor no seu tempo e necessidade.`,
    workflow_text_1: `Receba alertas em escalabilidade de todas as execuções auditas na sua base.`,
    workflow_text_2: `Saiba quais regras quebradas, processuais ou políticas corporativas, serão notificadas instantaneamente até que o problema seja resolvido.`,
    security_text_1: `Garanta a proteção integral da sua auditoria.`,
    security_text_2: `O Security fiscaliza e acompanha cada usuario da tecnologia, mostrando relatórios de quem realizou acessos e quais foram suas ações, até mesmo o desligamento de algum recurso ou regra de auditoria da ferramenta.`,
    security_text_3: `Seu negócio protegido o tempo todo.`,
  },
  buttons: {
    demo_btn_text: "Faça uma avaliação gratuita",
    demo_btn_alternative_text_1: "Acesse Gratuitamente",
    demo_btn_alternative_text_2: "AVALIE GRÁTIS",
    more_btn_text: "Saiba mais",
    contact_us_text: "Fale Conosco!",
    send_button_text: "Enviar",
  },

  examples: {
    title: "VEJA UM POUCO DA ATUAÇÃO DA HYAIA EM MULTISETORES",
    section_text:
      "Descubra um pouco do que a melhor tecnologia em Business Revenue Assurance pode fazer pela sua empresa.",
    telecom_sector: {
      billing_policy: {
        title: "BILLING POLICY ASSURANCE: ",
        section_text: "VALIDAÇÃO DO PROCESSO DE FATURAMENTO PÓS-PAGO",
        needs: {
          title: "Demanda:",
          section_text_1: "Análise de faturas por ano.",
          section_text_2: "Aumento do mapa de cobertura de controle.",
          section_text_3: "Redução de custo por fatura.",
        },
        solutions: {
          title: "Solução:",
          section_text:
            "Implantação da nossa tecnologia para Billing Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1: "Queda no ranking do  ",
          procon_text:
            "PROCON ( Fundação de Proteção e Defesa do Consumidor ).",
          section_text_2: "Foco da equipe no tratamento das exceções.",
          section_text_3: "Redução do custo operacional.",
        },
      },

      charging_policy: {
        title: "CHARGING POLICY ASSURANCE: ",
        section_text: "VALIDAÇÃO DO PROCESSO DE TARIFAÇÃO PRÉ-PAGO",
        needs: {
          title: "Demanda:",
          section_text_1: "Análise de tarifação de minutos promocionais.",
          section_text_2: "Análise de elegibilidade de clientes x promoções.",
          section_text_3: "Mensuração do impacto financeiro das divergências.",
        },
        solutions: {
          title: "Solução:",
          section_text:
            "Implantação da nossa tecnologia para Charging Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1: "Análise de 100% dos clientes.",
          section_text_2: "Redução de 80% no tempo do processo.",
          section_text_3: "Execução do processo com 10% do headcount.",
        },
      },
    },

    health_sector: {
      title: "SAÚDE",
      section_text: "",
      cost_policy: {
        title: "COST POLICY ASSURANCE: ",
        section_text: "ANÁLISE DE CUSTO DE PROCEDIMENTOS GERENCIADOS",
        needs: {
          title: "Demanda:",
          section_text_1: "Avaliação de 100% dos procedimentos gerenciados.",
          section_text_2: "Análise do custo e margem dos procedimentos.",
          section_text_3: "Identificação não conformidade com o protocolo.",
        },
        solutions: {
          title: "Solução:",
          section_text:
            "Implantação da nossa tecnologia para Cost Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1: "Análise de 100% dos protocolos gerenciados.",
          section_text_2: "Análise online dos procedimentos.",
          section_text_3: "Ganho de escala da análise de custo.",
        },
      },

      policy_assurance: {
        title: "MEDICAL PROTOCOL POLICY ASSURANCE: ",
        section_text: "ANÁLISE DE DESVIO NA PRÁTICA MÉDICA",
        needs: {
          title: "Demanda:",
          section_text_1:
            "Aplicar inteligência analítica às informações de atendimentos.",
          section_text_2:
            "Identificar e padronizar o perfil de consumo nas práticas médicas.",
          section_text_3:
            "Identificar desvios no perfil de atendimento médico.",
        },
        solutions: {
          title: "Solução:",
          section_text:
            "Implantação da nossa tecnologia para Medical Protocol Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1: "Análise de 100% dos atendimentos médicos.",
          section_text_2: "Redução de custos e visão detalhada de ofensores.",
          section_text_3:
            "Melhoria na comunicação de alinhamento estratégico do hospital.",
        },
      },
    },

    retail_sector: {
      title: "VAREJO",
      section_text: "",
      crm_policy: {
        title: "CRM POLICY ASSURANCE ",
        section_text: "VALIDAÇÃO DO PROCESSO DE FIDELIZAÇÃO DE CLIENTES",
        needs: {
          title: "Demanda:",
          section_text:
            "Validar a concessão de descontos com base na estratégia de fidelização.",
        },
        solutions: {
          title: "Solução:",
          section_text:
            "Implantação da nossa tecnologia para CRM Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1:
            "Análise de 100% das transações de compra de produtos.",
          section_text_2:
            "Redução de perdas por concessão indevida de descontos.",
          section_text_3: "Redução de 90% no tempo de análise das transações.",
        },
      },

      logistics_policy: {
        title: "LOGISTIC POLICY ASSURANCE: ",
        section_text: "VALIDAÇÃO DO PROCESSO DE DISTRIBUIÇÃO DE MEDICAMENTOS",
        needs: {
          title: "Demanda:",
          section_text_1: "Avaliação do processo de distribuição de produtos.",
          section_text_2:
            "Analisar e comparar os pedidos de compra e o fluxo de entregas de produtos.",
        },
        solutions: {
          title: "Solução:",
          section_text:
            "Implantação da nossa tecnologia para Logistic Policy Assurance.",
        },
        results: {
          title: "Resultados:",
          section_text_1: "Análise de 100% dos pedidos de compra  de produtos.",
          section_text_2: "Análise do processo de distribuição.",
          section_text_3:
            "Ganho de produtividade e maior eficiência na operação.",
        },
      },
    },

    know_more: {
      title: "QUER SABER MAIS?",
      section_text:
        "Entre em contato com nosso time comercial. E descubra como solucionar as preocupações do seu negócio com a Hyaia.",
    },
  },

  corp_chain: {
    title:
      "NÃO SEJA REFÉM DE SUAS PREOCUPAÇÕES, EXAMINE AS CADEIAS CORPORATIVAS DO SEU NEGÓCIO",
    analyze_corp_chain: {
      title: "",
      section_text_1:
        "Toda grande organização possui seus procedimentos, preceitos e políticas corporativas, dispostas em cadeias de processos.",
      section_text_2:
        "Gerir, monitorar, avaliar e auditar cada uma delas parece ser um enorme trabalho.",
      section_text_3:
        "Com a Hyaia seu ciclo de regras de negócios pode ser conferido em tempo real. Receba alertas instantâneos de qualquer quebra de norma ou processo.",
    },

    realtime_process: {
      title: "CADA PROCESSO E REGRA VISTOS EM TEMPO REAL",
      section_text:
        "Monitore e acompanhe tudo o que acontece nas suas cadeias corporativas. Veja as informações em dashboards interativos a cada atualização de dados.",
    },

    fin_chain: {
      title: "CADEIA FINANCEIRA",
      section_text_1:
        "A gestão financeira da sua organização é monitorada e auditada end to end. Regras para qualquer modelo de negócio, visando a redução de custos e aumento de lucro.",
      section_text_2:
        "Não pague por notas em duplicidade, impostos bitributados, guias com cálculos incorretos e entre outros aspectos, que possam ser pagos indevidamente.",
      section_text_3:
        "Coloque suas regras na Hyaia e deixe que ela monitore. Você será avisado se houver algum eventual equívoco no seu financeiro.",
    },

    op_chain: {
      title: "CADEIA OPERACIONAL",
      section_text_1:
        "Imagine acompanhar, medir nível de performance e resultado, otimizar regras de todas as operações do seu negócio.",
      section_text_2:
        "A Hyaia é a melhor solução tecnológica, capaz de realizar essa tarefa e gerar relatórios, em tempo real, sobre tudo o que acontece na sua empresa.",
    },

    corp_policies: {
      title: "POLÍTICAS CORPORATIVAS",
      section_text_1:
        "As políticas que regem seu negócio são acompanhadas, conferidas e monitoradas pelo que existe de melhor em Business Revenue Assurance com I.A.",
      section_text_2:
        "Elimine riscos e deixe sua empresa sempre de acordo com a lei, e com as regras de negócio com seus clientes.",
    },
  },

  database: {
    title: "A HYAIA CHEGA AONDE VOCÊ PRECISAR",
    section_text_1:
      "Se seus dados estiverem em Cloud ou On-Premise não tem problema.",
    section_text_2:
      "Nossa tecnologia, não intrusiva, chega até as suas bases e realiza os processos.",
    data_protection: {
      title: "A PROTEÇÃO DE SEUS DADOS É A NOSSA PRIORIDADE",
      section_text_1:
        "Uma ferramenta inovadora em leitura de dados e conversão de relatórios.",
      section_text_2:
        "Obedecendo a LGPD seus dados estarão protegidos e seguros, através das nossas conexões de leitura de informações.",
    },

    in_cloud_db: {
      title: "IN CLOUD",
      section_text:
        "Se suas informações estiverem na nuvem, por meio de conexões VPN, a Hyaia faz o exame de dados na própria base. Converte em dashboards e relatórios em tempo real, garantindo a sua segurança.",
    },

    on_premise: {
      title: "ON PREMISE",
      section_text_1:
        "Se sua base de dados é física, nosso time de especialistas vai até elas. Seguindo todos os procedimentos necessários, para que a leitura dos elementos seja feita de maneira segura e assertiva. ",
      section_text_2:
        "Nossa tecnologia não trabalha com importação de nenhum material. Apenas realiza a leitura e os converte externamente em relatórios e dashboards, para suas melhores tomadas de decisões.",
    },
  },

  rapid_dashboard: {
    title: "DASHBOARD DESIGNER ÁGIL & FÁCIL",
    section_text:
      "Converta dados brutos em ideias, de forma ágil e fácil, com o nosso dashboard customer. Não há necessidade de instalação!",
    drag_and_drop: {
      title: "DASHBOARD DESIGNER DE ARRASTAR & SOLTAR",
      section_text_1:
        "Sem as ferramentas corretas, para superar conexões, significados e insights, dados são apenas números. A Hyaia possibilita converter informações em dashboards com o nosso potente designer intuitivo.",
      section_text_2:
        "Comece a enxergar a performance, inclinações, antecipações e resultados através de gráficos, KPI, planilhas e muito mais. Com nosso visual de dashboards, de arrastar e soltar, você cria painéis em instantes.",
      section_text_3: "APP com “arrasta e solta” para colocar o Dashboard. ",
    },
    data_visualization: {
      title: "INÚMERAS MANEIRAS DE VISUALIZAR DADOS",
      section_text_1:
        "Acesse uma vasta biblioteca de ferramentas de designers, para lhe ajudar e dar vida aos seus dados.",
      section_text_2:
        "Desenvolva seus dashboards e impressione seu time e seus clientes, por meio de apresentações diretas, impactantes e agradáveis.",
    },

    impressive_dashboards: {
      title: "DASHBOARDS EXTRAORDINÁRIOS",
      section_text_1:
        "Relatórios e dashboards devem ser atraentes, diretos e objetivos. Valorizando as áreas que necessitam ser analisadas constantemente.",
      section_text_2:
        "Dashboards com visuais modernos, claros e objetivos, facilitam a leitura e impressionam seus usuários.",
      section_text_3:
        "Identifique padrões e valores discrepantes com dashboards bem desenvolvidos, e acesse instantaneamente os dados que você necessita.",
    },

    action: {
      title: "VEJA EM AÇÃO",
      section_text_1:
        "Pense em não ter que “copiar e colar” diferentes tipos de dados, e exportar documentos de texto para conseguir obter apenas uma planilha ou um gráfico.",
      section_text_2:
        "Não perca mais tempo! Inicie sua jornada pela Hyaia e acesse o futuro.",
    },

    widgets: {
      title: "WIDGETS DE VISUALIZAÇÃO DE DADOS",
      section_text_1:
        "Diversos tipos de gráficos. Mescle uma barra de colunas com um gráfico de linhas. Uma planilha, simples ou complexa, para apresentação de maneira clara.",
      section_text_2:
        "Filtre dados ou execute uma regra de negócio com um widget de entrada. Insira títulos, imagens e vídeos e deixe-o excelente.",
      section_text_3:
        "Valorize um medidor, um número de indicador chave, um gráfico com marcadores ou demonstre informações no Google Maps.",
      section_text_4:
        "Descubra a sua habilidade de design em dashboard, e vá além com os nossos editores.",
    },

    auto_update: {
      title: "ATUALIZAÇÃO AUTOMÁTICA",
      section_text_1:
        "Toda atualização, exclusão ou adição de dados em seu dashboard será imediatamente atualizado.",
      section_text_2:
        "A Hyaia fiscaliza todas as informações e atualiza todo painel conectado.",
    },

    fast_interaction: {
      title: "INTERAJA IMEDIATAMENTE",
      section_text:
        "Com a Hyaia suas informações ficam acessíveis em apenas um clique. Amplie, filtre ou detalhe e veja o que você precisa.",
    },

    custom_dashboards: {
      title: "DASHBOARDS CUSTOMIZADOS",
      section_text:
        "Dê a sua cara na aparência de qualquer dashboard. Mantenha a identidade de sua marca, empresa ou cliente. E desenvolva fontes, cores, plano de fundo e muito mais.",
    },
  },

  realtime_data: {
    title: "DADOS EM TEMPO REAL",
    section_text_1:
      "Atualizar seus dados minuto a minuto é primordial, porém ser mais rápido que isso seja necessário em algumas ocasiões.",
    section_text_2:
      "A Hyaia possui APIs que podem acionar upgrades das suas bases de dados ou use diretamente nossas APIs para adicionar e atualizar suas últimas linhas de dados instantaneamente.",
    what_is: {
      title: "O QUE SÃO DADOS EM TEMPO REAL?",
      section_text_1:
        "São informações imediatas disponíveis após serem levantadas ou atribuídas.",
      section_text_2:
        "O atraso é praticamente nulo entre o instante em que é criado e o momento em que é visto em seu dashboard.",
    },
    apis_and_webhooks: {
      title: "API & WEBHOOKS",
      section_text_1:
        "Desenvolva, envie, atualize ou exclua regras de negócios, políticas  estratégicas e operacionais em real time ou near real time, na sua cadeia de processos.",
      section_text_2:
        "Por meio de nossos terminais de dados, você consegue ter o controle total de seus agrupamentos de dados e apresentar seus dashboards até a próxima informação.",
      section_text_3:
        "Usando nossos terminais de dados REST, você pode ter controle total de seus conjuntos de dados e exibir seus painéis até a segunda informação.",
      section_text_4:
        "Aplique nossos módulos AUDIT e WORKFLOW, para verificar seus dados e detectar não conformidades, quebra de regras, fraudes e desempenho de performance em seus dashboards.",
    },

    triggers: {
      title: "ACIONADORES DE ATUALIZAÇÃO DE DADOS",
      section_text_1:
        "Ative atualizações de dados, uploads de dados parciais ou completos, qualquer ocorrência fora da Hyaia com nossas conexões de extremidade da API.",
      section_text_2:
        "Configure seu agrupamento de dados ou fontes, e ative de acordo com as demandas baseadas em quaisquer ocorrências, em seus aplicativos ou atuações dos usuários.",
    },

    notifications: {
      title: "ALERTAS & NOTIFICAÇÕES",
      section_text_1:
        "Através do módulo WORKFLOW, você pode desenvolver apps móveis e inovadores para web que realizam notificações e alertas imediatos, exibindo dashboards de gestão em real time.",
      section_text_2: "Com nosso AGENDADOR você pode chamar APIs externas.",
    },

    data_push_and_pull: {
      title: "DATA PUSH AND PULL",
      section_text:
        "Envie dados em tempo real (push) ou acione uma atualização de dados (pull) e deixe a Hyaia confrontar seus dados de acordo com a sua escolha.",
    },

    send_data: {
      title: "ENVIO DE DADOS EM TEMPO REAL",
      section_text_1:
        "Com auxílio das extremidades dos APIs da Hyaia, você consegue transferir dados de qualquer cliente, app ou outras ferramentas de integração em tempo real.",
      section_text_2:
        "Uma nova informação adicionada a uma planilha ou seu CRM, e você pode verificar instantaneamente, em seus dashboards, e visualizar os retornos.",
    },
    load_data: {
      title: "CARGA DE DADOS EM TEMPO REAL",
      section_text_1:
        "Caso seus apps não consigam enviar dados por meio da nossa API, poderão informar a Hyaia para conseguir os dados. Ao invés de enviar suas informações para a Hyaia, você enviará uma notificação para acessar os dados das inúmeras origens e atualizar seus dashboards.",
      section_text_2:
        "Ágil, intuitivo e fácil de implantar, e a Hyaia realiza todo o trabalho.",
    },
  },

  data_management: {
    title: "GESTÃO DE DADOS FACILITADA",
    section_text:
      "Concilie, confronte, audite, limpe, mescle seus dados com a Hyaia, em sua plataforma ETL, prática e fácil de usar.",
    reconcile: {
      title: "MUITO ALÉM DE SOMENTE VISUALIZAÇÃO DE DADOS, UMA FERRAMENTA ETL",
      section_text_1:
        "Uma vez que a Hyaia estiver conectada às suas bases de dados, sua empresa estará pronta para converter os dados em informações úteis. A Hyaia é uma poderosa Data Source, capaz de limpar, conciliar, confrontar, padronizar, enriquecer e combinar inúmeras fontes de dados.",
      section_text_2: "",
      section_text_3:
        "Sua necessidade é uma coluna auditada que suas informações de origem ainda estão cheias de não conformidades? Desenvolva na Hyaia e cada vez que seus dados realizarem um upgrade, as auditorias também serão atualizadas.",
      section_text_4:
        "Talvez você necessite de informações agrupadas de um modo específico? Crie um agrupamento na Hyaia e sempre será sincronizado, e imediatamente disponível para ser visualizado em seus painéis.",
    },

    datasource: {
      title: "DADOS HIGIENIZADOS",
      section_text_1:
        "Organizar suas informações para uso em dashboards nem sempre é simples. Fazer com que todos os seus dados sejam uniformes e prontos para serem visualizados, em uma planilha ou gráfico, é uma tarefa árdua e necessita de muita intervenção manual de informações.",
      section_text_2:
        "A Hyaia resolve essas angústias com nossas ferramentas de padronização e higienização de dados. Nosso módulo Big Data garante que todos os seus dados de texto estejam no caso corretos, sem espaços extras ou que suas datas não estejam em 1719 ou em 2399. Esse módulo de Machine Learning permite que todos os valores não conformes convertam-se em um, por exemplo “US”, “U.S.” e “USA” , que podem ser convertidos automaticamente para “Estados Unidos”.",
    },

    agile_connection: {
      title: "CONCILIAR, MESCLAR & COMBINAR DADOS",
      section_text_1:
        "Você tem necessidade de combinar suas metas de vendas com seus números de vendas atuais? Imagine conectar os dados de passivos aos dados de saídas? Nossas ferramentas de Audit, Machine Learning, Big Data da Hyaia permite conciliar e combinar informações de várias origens em uma única planilha.",
      section_text_2:
        "Todos os elementos mesclados continuam sincronizados com os grupos de informações individuais, assim você não precisa corresponder novamente. Apenas atualize cada fonte de dados individual e o composto das informações serão retificadas.",
    },

    data_integrity: {
      title: "TRANSFORMAR DADOS            ",
      section_text:
        "O módulo análises permite usar regras de negócios, políticas estratégicas e operacionais familiares, para criar tuning ou novas ordens. Autorizando a Hyaia analisar suas bases, sem precisar alterar seus dados de origem.",
    },

    merge_data: {
      title: "FUNDIR DADOS",
      section_text_1:
        "Examine os mesmos aspectos de inúmeras equipes, sistemas e regiões, e concentre-os em um agrupamento de dados. Faça isso de um modo acessível e automático com nossa junção de dados.",
      section_text_2:
        "A Hyaia representa os fatos permitindo que, cada usuário final, sustente seus próprios conteúdos da maneira escolhida e privada. Você pode fazer uma junção de dados para criar dashboards diferenciados e completos.",
    },

    easy_integration: {
      title: "FÁCIL INTEGRAÇÃO",
    },

    cloud_or_onpremise: {
      title: "ONDE ESTÃO SEUS DADOS?",
      cloud: {
        title: "EM NUVEM?",
        section_text:
          "Não há problemas, somos uma ferramente SaaS e fazemos as conexões direto na sua cloud.",
      },

      onpremise: {
        title: "EM SUA INFRAESTRUTURA?",
        section_text:
          "Realizamos a conexão de maneira física, na sua base de dados ou servidores, promovendo resultados em near real time.",
      },
    },
  },

  datasources: {
    title: "DATA SOURCES",
    section_text:
      "Concilie e confronte todos os dados da sua organização em um só lugar, garantindo consistência e qualidade dos dados com agilidade e facilidade na geração de indicadores, dashboards e relatórios.",
    reconcile: {
      title: "CONCILIE, CONFRONTE E HIGIENIZE SEUS DADOS EM UM SÓ LUGAR",
      section_text:
        "Trabalhe com a Hyaia para unificar sua leitura de dados e auditá-los em um único local. Desenvolva interoperabilidade entre diferentes agrupamentos de dados e diferentes sistemas para trabalhar. Inpute seus apps externos, como o R e SPSS, para uma analise profunda e assertiva de dados.",
    },

    datasource: {
      title: "BENEFICIOS DE UM DATA SOURCE",
      section_text_1:
        "Avalie a imagem e classificação externas da sua empresa através da Hyaia.",
      section_text_2:
        "Totalmente fácil de usar e intuitivo, o nosso assistente de conexão de dados te orientará a conectar as suas contas de mídias sociais e analisa-las em minutos.",
    },

    agile_connection: {
      title: "CONEXÃO ÁGIL",
      section_text:
        "A Hyaia possui tecnologia única, linguagem própria de 4ª geração, alto poder digital e conexão com qualquer tipo de fonte de dados. Fornece acesso, em real time ou near real time, de análises de todos os parâmetros da sua empresa. Garantindo resposta rápida seja qual for a adversidade que consuma sua margem de lucro.",
    },

    data_integrity: {
      title: "INTEGRIDADE DE DADOS",
      section_text:
        "Através de nossas tecnologias em Big Data,  a qualidade e integridade de seus dados serão cada vez mais profundas e totalitárias, mostrando a origem, razão e conformidade de cada informação.",
    },

    easy_integration: {
      title: "FÁCIL INTEGRAÇÃO",
      section_text_1:
        "Independente de qual seja seu sistema, app, plataforma, base de dados ou API, desde um complexo ERP ou CRM a um arquivo txt, a Hyaia consegue integrar as informações de cada um deles simultaneamente.",
      section_text_2:
        "Diminuindo a não interoperabilidade, promovendo conciliações, confronto e aplicações de regras de negócios e políticas corporativas de ponta a ponta na sua empresa.",
    },
  },

  interactive_dashboards: {
    smart_dashboards: {
      title: "DASHBOARDS INTERATIVOS & INTELIGENTES",
      section_text:
        "Transforme seus dados em informações cirúrgicas com nossos dashboards inteligentes, e tome decisões assertivas para seu negócio.",
    },
    fully_interactive: {
      title: "DASHBOARDS TOTALMENTE INTERATIVOS",
      section_text_1:
        "Em apenas um clique incorpore cruzamento de informações com detalhes em seus gráficos, KPIs e tabelas. Mostre sub-tabelas e inúmeros dashboards. Expanda e comprima os gráficos ou desloque as escalas de tempo. Agrupe por meses, semestres ou anos. Para garantir um excelente fluxo de informações, as interações são fundamentais para torná-las interessantes.",
      section_text_2: "",
    },
    click_and_filter: {
      click: {
        title: "CLIQUE & FILTRE",
        section_text_1:
          "Escolha uma coluna de um gráfico de barras e filtre a planilha ao lado dela. Selecione um indicador e passe para outro dashboard, com mais informações sobre o mesmo.",
        section_text_2:
          "Clique em uma linha em uma planilha e exponha todo o dashboard. Veja tudo facilmente configurado por meio da guia de interações, mediante as manifestações de cada widget.",
      },
      users_and_teams: {
        title: "PARÂMETROS DE EQUIPE & USUÁRIOS",
        section_text_1:
          "Qual a sua necessidade? 4 Dashboards? Um para cada nível hierárquico da sua organização ou por setor liberado, de acordo com a regra de acesso de cada usuário?",
        section_text_2:
          "Defina os parâmetros de cada usuário na própria plataforma e filtre seus gráficos, de acordo com a necessidade e liberação de cada usuário.",
      },
      table: {
        title: "TABELAS DE APERFEIÇOAMENTO",
        section_text_1:
          "Através das nossas planilhas de detalhamento e widgets funcionais, detalhe qualquer agrupamento de dados e simultaneamente mantenha os resumos de nível avançado, claros e disponíveis.",
        section_text_2: "Não precisa configurar nada, apenas arraste e solte.",
      },
      easy_nav: {
        title: "NAVEGUE DE MANEIRA FÁCIL",
        section_text_1:
          "Desenvolva navegação entre dashboards, aplicativos externos, sites, vídeos e imagens.",
        section_text_2:
          "Utilize os menus com botões, grupos de botões, gráficos, imagens e indicadores.",
        section_text_3:
          "Mostre uma história de dados mais sofisticada desenvolvendo uma trilha nas suas métricas.",
      },
    },
    easiest_tool: {
      title: "UMA FERRAMENTA MAIS FÁCIL E INTELIGENTE PARA RELATÓRIO",
      section_text_1:
        "A Hyaia pode informar quando houver desvios de desempenho em suas regras, processos e políticas operacionais.",
      section_text_2:
        "Use seu tempo na construção de leads e gaste menos energia com planilhas.",
    },
  },

  partners: {
    title: "PARCERIAS",
    section_text:
      "Trabalhamos com os parceiros líderes de mercado em tecnologia e inovação, e entendemos que os relacionamentos colaboram para incrementar nosso grau de competitividade.",
  },

  reports: {
    title: "RELATÓRIOS NA PALMA DA MÃO",
    section_text_1:
      "Tenha acesso aos relatórios da sua empresa na palma da sua mão em real time ou near real time.",
    section_text_2:
      "A Hyaia permite que você acesse suas informações de qualquer lugar com nossos dashboards inteligentes.",
    access_form: {
      title: "ACESSE DE ONDE VOCÊ ESTIVER",
      section_text_1:
        "Instale o app para iOS ou Android e veja seus dashboards em qualquer lugar.",
      section_text_2:
        "Totalmente responsivos nossos dashboards se adaptam a variados tamanhos de tela. Seja via WI-FI ou com sua rede de dados você terá acesso a seus relatórios na hora que desejar.",
    },
    our_apps: {
      title: "COM NOSSOS APPS VOCÊ CONSEGUE...",
      section_text:
        "Sempre estamos atualizando e adicionando recursos aos nossos apps, tanto para Android quanto para iOS.",
      functionalities_list: {
        dashboards_text: "Visualizar seus dashboards",
        filter_text: "Filtrar, detalhar e ampliar",
        notifications_text: "Receber notificações",
        export_pdf_text: "Exportar em PDF",
        send_email_text: "Enviar por email",
      },
    },
    suitable_apps: {
      title: "APPS ADEQUADOS PARA TABLET",
      section_text: "Em versão para tablets. Disponível para Android e iOS.",
    },
    potency: {
      title: "PEQUENO NO TAMANHO, GIGANTE NA POTÊNCIA",
      potency_smartphone: {
        section_text_1:
          "Ideais para conseguir KPIs de desempenho, os smartphones são excelentes nesse formato. ",
        section_text_2:
          "Acesse de maneira simples planilhas e gráficos com uma formidável aparência. Garanta seus dados nas pontas dos dedos.",
      },
      potency_tablet: {
        section_text_1: "Obtenha mais visualizações pela tela do seu  tablet.",
        section_text_2:
          "Tablets mais recentes garantem uma interação maior, com suas canetas touch, em nossos dashboards.",
        section_text_3:
          "Perfeitos para demonstrações, vendas ou reuniões. Impressione com nossos dashboards.",
      },
    },
  },

  scheduling: {
    title: "AUTOMAÇÃO, AGENDAMENTO & ALERTAS",
    section_text:
      "Seus dados atualizados automaticamente e publicados em dashboards e workflows, baseado em ocorrências, tudo decorrente de nossa tecnologia de Business Revenue Assurance.",
    know_everything: {
      title: "SAIBA TUDO O QUE ACONTECE EM SEU NEGÓCIO",
      section_text:
        "Deixe seus dados atualizados e receba alertas quando houver a quebra de qualquer regra de negócio, política operacional, detecção de fraude ou outra não conformidade pelo nosso módulo de workflow. Resolva seus aborrecimentos rapidamente e melhore os processos da sua empresa.",
    },

    kpis: {
      realtime_kpis: {
        title: "KPIS EM REAL TIME",
        section_text:
          "Confronte seus KPIs com o nosso módulo INDICATOR, e veja, em real time ou near real time, os nossos KPIs sobre seus dados e compare com os indicadores do seu negócio.",
      },

      alerts: {
        title: "ALERTAS EM TEMPO REAL PARA NÃO CONFORMIDADE",
        section_text:
          "Monitore 100% dos seus processos e regras de negócio, e receba alertas em tempo real sobre fraudes, quebra de regras e processos, perda financeira e não conformidades.",
      },

      data: {
        title: "DADOS E REGRAS DOS SEUS CLIENTES ACOMPANHADOS INSTANTANEAMENTE",
        section_text_1:
          "Garanta a interoperabilidade e comunicação dos processos e regras de seus clientes. A Hyaia consegue acompanhar, auditar e fiscalizar todas as políticas contratuais dos seus clientes, gerar alertas e notificações quando houver risco e ameaça. Dessa forma, impedindo quebras contratuais, multas, risco a imagem da sua empresa e perda de clientes.",
        section_text_2: "Expanda sua produtividade.",
      },

      manage: {
        title: "ACOMPANHE O DESENVOLVIMENTO DE PERFORMANCE DO SEU NEGÓCIO",
        section_text:
          "Seja mais ágil, monitorando seus processos, setores e equipes. Acompanhe o fluxo de sua empresa e tome decisões estratégicas e assertivas, com base nas informações geradas pela Hyaia.",
      },

      data_automatization: {
        title: "AUTOMAÇÃO DE DADOS",
        section_text:
          "Defina e esqueça. A automação de dados da Hyaia garante que seus dados e informações estejam regularmente sempre recentes em todas as suas fontes. Semanalmente, todos os dias e a cada minuto.",
      },

      data_update: {
        title: "ATUALIZAÇÃO DE DADOS",
        section_text:
          "Seus relatórios e dashboards são atualizados a cada dado novo imputado. Todos analisados, auditados e conciliados com seus processos, regras e políticas corporativas.",
      },
    },
  },

  connectors: {
    title: "CONECTORES DE DADOS",
    section_text:
      "A Hyaia se conecta com todo tipo de banco de dados, sistemas, arquivos e base de informações, independente do formato, empoderando-a como uma tecnologia inclusiva.",
    reconcile: {
      title: "PRECISA CONCILIAR E CONFRONTAR SEUS DADOS?",
      section_text:
        "Seja onde estiver seus dados (planilhas, txt, app, banco de dados, em nuvem ou local físico) a Hyaia pode se conectar com todos simultaneamente. E aplicar regras de negócios, políticas estratégicas e operacionais da sua organização. Detectando se houver: irregularidade, exposição ao risco, fraudes e perdas financeiras.",
    },
    business_apps: {
      title: "APLICATIVOS DE NEGÓCIOS",
      section_text_1:
        "Seus apps de gestão possuem dados valiosos? Você consegue ler, conciliar e confrontá-los em tempo real?",
      section_text_2:
        "As conexões seguras da Hyaia podem fazer isso, como também gerar indicadores e workflows, sobre qualquer eventualidade que sua base de dados possua e que afete os lucros de sua organização.",
      section_text_3:
        "Não perca tempo e dinheiro, começe acompanhar sua empresa na palma da sua mão.",
    },
    social_media_connectors: {
      title: "CONECTORES DE MÍDIA SOCIAL",
      section_text:
        "Avalie a imagem e classificações externas da sua empresa pela Hyaia. Totalmente fácil de usar e intuitivo, nosso assistente de conexão de dados auxiliarão a conectar as suas contas de mídia social e analisá-los em minutos.",
    },
    cloud_connectors: {
      title: "BASE DE DADOS CLOUD & ONPREMISE",
      section_text:
        "Caso possua um banco de dados, seja em nuvem com um terabyte no Google Big Query ou no Amazon RedShift, em um banco de dados local relacional Oracle ou MySQL, e deseja conciliá-los e confrontá-los em tempo real, vendo tudo em dashboards, nós temos a resposta correta para sua necessidade.",
    },
    spreedsheet: {
      title: "PLANILHAS & ARQUIVOS DE TEXTO",
      section_text_1:
        "Empresas sempre terão como parte importante de seus dados em planilhas e arquivos de texto, devido a simplicidade no que há de mais básico para base de dados.",
      section_text_2:
        "Na Hyaia nossos conectores possibilitam a leitura, conciliação e confronto de maneira fácil e rápida, a diversos serviços de armazenamento de dados. Até seus e-mails podem ser agregados e transformados em dashboards.",
    },
    web_services: {
      title: "WEB SERVICES & APIS",
      section_text:
        "A Hyaia é uma ferramenta incrível, seja qual for a sua integração. Através do nosso Web Service Connector, podemos nos conectar a qualquer API, REST ou SOAP, usando diversos tipos de autenticação, do Basic ao OAuth2 ou AWS Signature. Independentemente se as APIs, que requerem parâmetros ou macros, podem ser utilizadas para potência total e automação. Veja soluções como: XML, JSON ou Delimited. ",
    },
    thousands: {
      title: "CONECTE-SE A MILHARES DE APLICAÇÕES ATRAVÉS DA HYAIA",
      section_text:
        "Na Hyaia você pode conciliar e confrontar fluxos de trabalhos de dados, de inúmeras aplicações simultaneamente.",
    },
    safe_information: {
      title: "SUAS INFORMAÇÕES ESTÃO SEGURAS",
      section_text:
        "Não se preocupe, seus dados não são importados. A nossa solução lê todos os dados de sua fonte de origem, e gera todos os dashboards, workflows e relatórios necessários, em tempo real, através de conexões VPN. Apenas você e pessoas autorizadas têm acesso às informações lidas pela Hyaia. ",
    },

    customer_testimonials: {
      title: "GRANDES CLIENTES PELO MUNDO",
      section_text:
        "Veja o que nossos clientes pensam sobre a atuação da Hyaia em seus negócios",
    },

    lets_go: {
      section_text: ` Não perca tempo e comece a usar a melhor tecnologia do mundo em BRA.`,
    },
  },

  health: {
    title: "SEU HOSPITAL SAUDÁVEL FINANCEIRAMENTE",
    section_text:
      "Acompanhe, de ponta a ponta, todos os procedimentos, convênio de saúde, farmácia, recorrência, contratos e aumente os lucros da sua organização para um crescimento exponencial.",
    perform_better: {
      title: "EXECUTE MELHOR SUA ESPECIALIDADE COM DADOS EM TEMPO REAL",
      section_text_1:
        "Encontre maneiras de reduzir custos, aumentar a qualidade do serviço e otimizar o atendimento ao paciente.",
      section_text_2:
        "Com relatórios atualizados, você tem acesso a informações precisas e corretas em qualquer aspecto do seu serviço de saúde.",
    },
    medical_bill_list: {
      medical_bill: {
        title: "CONTAS MÉDICAS",
        section_text_1:
          "Concilie e audite em tempo real prontuários médicos, contratos, preenchimentos de guias e convênios.",
        section_text_2:
          "Corte custos, mantenha as finanças organizadas, receba corretamente os valores repassados pelo convênio ou consultas particulares. Diminuindo assim, as glosas médicas.",
      },

      management_procedures: {
        title: "PROCEDIMENTOS GERENCIADOS",
        section_text:
          "Com alto poder computacional e linguagem própria de 4ª geração, a Hyaia monitora e garante o conjunto de ações assistenciais e administrativas necessárias, suficientes para a realização integral de procedimentos cirúrgicos. Contemplando recursos humanos, instalações físicas, equipamentos, instrumentos e materiais de insumo inerentes ao processo assistencial.",
      },

      pharmacy: {
        title: "FARMÁCIA",
        section_text:
          "Garanta o uso seguro e racional dos medicamentos prescritos, atendendo a demanda de pacientes hospitalizados. Maior controle e sem desperdícios, tudo na medida certa.",
      },

      profit: {
        title: "FATURAMENTO",
        section_text_1:
          "Contas conferidas, auditadas e comprovadas antes de serem encaminhadas às operadoras de saúde.",
        section_text_2:
          "Maior agilidade no envio de faturas, e velocidade no recebimento dos pagamentos.",
      },

      glosa: {
        title: "GLOSA",
        section_text:
          "Acabe com os problemas de comunicação, e tenha relatórios precisos em tempo real. Reduza ao máximo a glosa na sua organização de saúde.",
      },
      contracts: {
        title: "CONTRATOS",
        section_text_1:
          "Garanta as regras de cada contrato e tenha uma gestão hospitalar lucrativa.                ",
        section_text_2:
          "Impute automaticamente as regras de contratos da sua organização de saúde, e acompanhe em tempo real todos os parâmetros de conformidade estabelecidos.",
      },
    },
  },

  industry: {
    title: "SUA EMPRESA MAIS PRODUTIVA COM MENOS GASTOS",
    section_text_1:
      "Use a Hyaia para gestão e acompanhamento de todos os seus departamentos, cadeias de produção, operacionais e financeiras do seu negócio.",
    section_text_2:
      "Veja, em tempo real, tudo o que é perdido e recuperado nas suas ações diárias na companhia.",
    economy: {
      title:
        "CADA CENTAVO ECONOMIZADO NA SUA LINHA DE PRODUÇÃO PODEM SE TORNAR MILHÕES",
      section_text_1:
        "Promova o tuning da sua cadeia de processos e melhore suas regras de negócio em suas linhas de produção, tornando-se cada vez mais rápido e barato.",
      section_text_2:
        "Através da tecnologia Deep Learning a Hyaia pode exponenciar seus lucros e trazer resultados incríveis para sua empresa.",
    },

    artificial_inteligence: {
      title: "INTELIGENCIA ARTIFICIAL NO SEU NEGÓCIO",
      section_text:
        "Com nossas tecnologias, de Business Intelligence, Business Revenue Assurance, Big Data, Machine Learning, Deep Learning e Internet Of Things, tenha uma visão melhor e maior controle de processos, regras, departamentos, supply chain, logística reversa, WMS, MRP1, MRP2, inventário, EMII, CMN entre outros fatores importantes da sua organização.",
    },

    consulting: {
      title: "AUDITORIA E CONSULTORIA",
      section_text_1:
        "Conte com nossos times de consultores e tecnologia para podermos auxiliar na estruturação de processos, regras e políticas, otimizando no exame do seu negócio para relatórios precisos e em tempo real.",
      section_text_2:
        "Promova Revenue Assurance nas cadeias operacionais e financeiras da sua empresa.",
      section_text_3:
        "Audite seus sistemas de ERP, CRM, WMS, Risco & Compliance e tributos.            ",
    },

    antifraud: {
      title: "ANTIFRAUDE",
      section_text:
        "Proteja sua empresa e detecte qualquer fraude em tempo real. Cada centavo pode fazer a diferença no final.",
    },

    kpis: {
      title: "KPIS & OKRS",
      section_text_1:
        "Confronte os KPIs e OKRs da sua empresa com dados exatos e conciliados.            ",
      section_text_2:
        "A Hyaia pode gerar indicadores com base nos dados auditados e comparar com os indicadores dos seus sistemas, mostrando discrepâncias para melhora de performance.",
    },

    workflow: {
      title: "WORKFLOW DE PROBLEMAS EM TEMPO REAL",
      section_text_1:
        "Seja notificado imediatamente a cada irregularidade que consuma seus lucros.",
      section_text_2:
        "Com a Hyaia você recebe alertas, em real time, com grau de escalabilidade até que o problema seja resolvido.",
      section_text_3: "Quanto mais rapida a ação menor a perda.",
    },
  },

  retail: {
    title: "GARANTA LUCROS NO B2C",
    section_text:
      "Tenha uma visão completa e acompanhe, em tempo real, tudo o que acontece no seu negócio de varejo.",
    numerous_processes: {
      title:
        "INÚMEROS PROCESSOS NO VAREJO PARECE ALGO IMPOSSÍVEL DE SE CONTROLAR, COM A HYAIA ISSO NÃO É PROBLEMA",
      section_text_1:
        " Acompanhe, em tempo real, a performance da sua loja, e-commerce e omnichannel.",
      section_text_2:
        "Concilie sua base de dados e resolva problemas em tempo recorde com nossos dashboards interativos.",
    },
    product_performance_list: {
      product_performance: {
        title: "DESEMPENHO DO PRODUTO",
        section_text:
          "Veja o desempenho de seus produtos, em todos os canais de vendas, em tempo real. Atualizações automáticas garantirão que você esteja sempre informado.",
      },
      inventary_control: {
        title: "CONTROLE DE INVENTÁRIO",
        section_text:
          "Mantenha o estoque baixo, relacione-se com modelos preditivos, rastreie itens na prateleira com mais facilidade e mantenha todos os preços atualizados com um dashboard, em real time.",
      },
      profit_up: {
        title: "AUMENTO DOS LUCROS",
        section_text:
          "Economize muito, tendo uma visão geral e detalhada de todo seu negócio.",
      },
      orders: {
        title: "PEDIDOS & FATURAMENTO",
        section_text:
          "Monitore pelos dashboards inteligentes, relatórios em tempo real, todos os pedidos e faturas, dentro das regras e políticas corporativas da sua empresa.",
      },
      analysis: {
        title: "ANÁLISE DE INDICADORES DO E-COMMERCE",
        section_text:
          "KPIs precisos do seu negócio online em tempo real. Tome decisões e crie estratégias para alcançar metas com indicadores essenciais e fidedignos.",
      },
      customer: {
        title: "CONQUISTA DE CLIENTES",
        section_text:
          "Descubra rapidamente quais vendas foram eficazes. Acompanhe suas taxas de conversões, tráfego de novos clientes, centralize receitas e otimize suas estratégias de marketing.",
      },
    },
  },

  telecom: {
    title: "O NOVO E MELHOR CONCEITO EM BRA PARA TELECOM",
    section_text_1: "Com a Hyaia a interoperabilidade em Telecom é possível.",
    section_text_2:
      "Melhore seus processos e qualidade de dados com nossa tecnologia. Otimizando seus lucros, receita, fluxo de caixa sem influenciar na demanda de serviço.",
    invoice: {
      title: "FATURAS INCONCILIÁVEIS PODEM SAIR CARO            ",
      section_text_1:
        "Através da Hyaia as faturas e planos dos seus clientes estarão corretos e sem equívocos.",
      section_text_2:
        "Cada cliente terá um plano e uma regra. Tenha o melhor em BRA para acompanhar e gerir individualmente.",
      section_text_3:
        "Tenha relatórios em tempo real, em dashboards, e mostre ao seu time para aprimorar a gestão da sua empresa.",
    },
    cdr_list: {
      cdr: {
        title: "CDR",
        section_text_1:
          "Audite todas as informações de registros de chamadas dos seus clientes, aplicando as regras de cada plano em cada chamada.",
        section_text_2:
          "O controle integral das ligações dos seus clientes pode ser uma grande fonte de economia, de lucros e proteção contra cobrança indevida ao cliente.",
      },

      routing: {
        title: "ROTEAMENTO INCORRETO                ",
        section_text_1:
          "A entrega de dados para cada plano deve ser eficaz e monitorada, garantindo lucro para empresa e a satisfação ao cliente.",
        section_text_2:
          "A Hyaia pode conferir e notificar falhas de roteamento. Comunicando à operadora, em tempo real, situações que criem problemas entre o cliente e a empresa de Telecom, minando seus lucros, risco e imagem.",
      },

      business_rules: {
        title: "REGRAS DE NEGÓCIOS IMPRECISOS                ",
        section_text_1:
          "Veja quais regras são inválidas, inúteis ou desatualizadas em seu sistema com a Hyaia.",
        section_text_2:
          "Promova um tuning de regras e processos, para que seu fluxo de serviços seja cada vez mais assertivo e mais lucrativo.",
      },

      subscriptions: {
        title: "PROVISIONAMENTO DE ASSINANTES                ",
        section_text_1:
          "Identifique o grau de funcionalidade e a clareza do provisionamento dos assinantes de sua operadora.",
        section_text_2:
          "Acompanhe pelos dashboards interativos o comportamento dos sistemas em relação à implantação ou adaptação de serviços aos seus usuários.",
        section_text_3:
          "Detecte erros de configuração ou instalação sistêmica, e haja antecipadamente, garantindo o grau de satisfação de seus assinantes.",
      },

      precision_errors: {
        title: "FALHAS DE PRECISÃO DE CLASSIFICAÇÃO E COBRANÇA                ",
        section_text_1:
          "Acompanhe em tempo real regras de negócios sobre preço, cobrança e negociação de acordo com o tamanho de cada cliente.",
        section_text_2:
          "Acabe com as não conformidades, exposição ao risco, perdas financeiras e fraudes através dos nossos módulos.",
      },
    },
  },

  education: {
    title: "COM A HYAIA SEU SISTEMA DE ENSINO É NOTA 10",
    section_text_1:
      "Instituições de ensino possuem inúmeros processos com inúmeras regras para garantir a qualidade, gerenciamento e controle do fluxo de trabalho e demanda de alunos. Sem contar sistemas, planilhas, históricos entre outros dados, que são de suma importância para a entidade mediante a órgãos regulatórios como o MEC (Ministério da Educação).",
    section_text_2:
      "Garantir a fluência da cadência educacional e financeira da sua instituição de ensino é nossa especialidade.",
    e2e_control: {
      title: "CONTROLE DE PONTA A PONTA",
      section_text:
        "Nossa tecnologia não é intrusiva, a Hyaia se comunica com qualquer base de dados e em qualquer formato. Realizando a leitura e aplicação de processos, regras e políticas corporativas de sua organização, gerando relatórios em tempo real através de dashboards modernos e interativos.",
    },

    financial_list: {
      financial: {
        title: "FINANCEIRO",
        section_text_1: "Monitore e audite suas contas em tempo real.",
        section_text_2:
          "Saiba onde, quando e como está cada centavo em sua entidade de ensino.",
        section_text_3:
          "Corte gastos, encontre fraudes e veja seus lucros aumentarem.",
      },
      register: {
        title: "MATRÍCULAS",
        section_text_1:
          "Garanta a gestão das matrículas de seus alunos, monitorando pagamentos, cláusulas contratuais, fluxo de entradas e saídas de alunos por meio de indicadores fidedignos em tempo real.",
        section_text_2:
          "Tome decisões rápidas e assertivas para a expansão de sua instituição de ensino.                ",
      },
      student_allocation: {
        title: "LOCAÇÃO DE TURMAS",
        section_text_1:
          "Monitorar e gerenciar turmas não é uma tarefa fácil, infinitos fatores podem potencializar ou desconstruir as turmas de sua motivação educacional.",
        section_text_2:
          "A Hyaia garante que suas regras, para formação, locação, monitoramento e desenvolvimento de turmas, sejam acompanhadas e relatadas da melhor maneira possível.",
      },
      history: {
        title: "HISTÓRICO ESCOLAR",
        section_text_1:
          "Notas, faltas, médias, aprovações, recuperações, TCC (trabalho de conclusão de curso), monografias multiplicadas pela quantidade de alunos é uma cadeia educacional imensa para controlar e monitorar, parecendo até impossível em tempo real.",
        section_text_2:
          "Mas com a Hyaia isso pode ser facilmente resolvido, suas regras de histórico escolar junto com seus processos podem ser acompanhados e relatados, em tempo real, garantindo eficácia do seu acadêmico e a satisfação dos seus alunos.",
      },
    },
  },

  ecommerce: {
    title: "SEU E-COMMERCE SEMPRE EFICIENTE E GERANDO LUCRO",
    section_text_1:
      "Vendas online são o futuro, mais de 56% das vendas físicas no varejo são influenciadas por algum tipo de canal digital nos dias de hoje.",
    section_text_2:
      "Porém, garantir a interoperabilidade entre a cadeia física e digital no e-commerce não é algo tão simples.",
    section_text_3:
      "A Hyaia é a melhor solução pra acompanhar seus processos e regras de e-commerce.",
    fast_efficient: {
      title: "DIGITAL, RÁPIDO E EFICIENTE",
      section_text:
        "Veja em real time todos os processos, regras e políticas corporativas do seu e-commerce, fiscalizadas e auditadas em toda a base de dados das suas tecnologias.",
    },

    card_fraud_list: {
      fraud: {
        title: "FRAUDE COM CARTÃO",
        section_text:
          "Detecte compras fraudulentas e seja notificado imediatamente, garanta a credibilidade das suas vendas. Evite perdas de mercadorias e cancelamento de vendas.",
      },
      logistics: {
        title: "LOGÍSTICA",
        section_text_1:
          "Com os módulos da Hyaia, como Big Data, Machine Learning e Deep Learning, você pode cortar custos e aumentar seus lucros.",
        section_text_2:
          "Saiba onde, como e em qual Estado estão seus produtos, desde o regimento até a entrega ao cliente final.",
      },

      reverse_logistics: {
        title: "LOGÍSTICA REVERSA",
        section_text_1:
          "Receber um produto devolvido envolve uma série de procedimentos, regras e processos que custam dinheiro. E fica mais caro quando não se tem controle de ponta a ponta da logística reversa e a garantia de monitoramentos das suas políticas corporativas.",
        section_text_2:
          "Acompanhe, em real time, onde e como seus produtos estão no processo de devolução, corte custos, otimize processos e aumente suas margens de lucro.",
      },

      churn: {
        title: "CHURN",
        section_text_1:
          "Quanto vale um cliente que desiste da sua marca, produto ou serviço? Mais caro ainda é se ele difamar seu e-commerce.",
        section_text_2:
          "Entender e acompanhar, via indicadores, o porquê e quanto dos seus clientes estão deixando de comprar de você é algo que a Hyaia fornece ao seu negócio, para que você tome decisões e converta perdas em fidelização.",
        section_text_3: `Aumente sua carteira e tenha o melhor "boca a boca" da sua empresa, com as informações geradas pela Hyaia.`,
      },
    },
  },

  public_sector: {
    title: "AUMENTO DE ARRECADAÇÃO E PERFORMANCE DA GESTÃO PÚBLICA",
    section_text:
      "A Hyaia pode otimizar as fontes de receitas do município e monitorar desenvolvimento de performance das secretarias e setores públicos.",
    mgnt: {
      title:
        "A GESTÃO PÚBLICA NÃO É ALGO TÃO SIMPLES, MAS VIA HYAIA TUDO É POSSÍVEL",
      section_text_1:
        "O setor público possui vários setores, com infinitos processos, diversas regras e políticas de gestão. A quantidade de dados e sistemas para essa demanda é alta, e o acompanhamento de todos eles, multiplicados pelo número da população, é mais difícil ainda.",
      section_text_2:
        "A Hyaia é o melhor sistema para acompanhamento e gestão de processos no setor público. Promovendo mais resultados que serão convertidos em benefícios à população.",
    },

    warranty_list: {
      warranty: {
        title: "GARANTIA E RECUPERAÇÃO DE IMPOSTOS",
        section_text_1:
          "Com capacidade de processar mais de 20 bilhões de cruzamento de dados/dia, descobre impostos pagos a menos com correções, multas e juros atualizados.",
        section_text_2:
          "Tenha, em tempo real, as fontes de receitas municipais atualizadas para ações que vão beneficiar a população.",
      },
      service_high: {
        title: "PERFORMANCE DE SECRETARIAS, SERVIÇOS E SETORES",
        section_text:
          "Acompanhe, compare e veja os desenvolvimentos dos setores e secretarias municipais ou estaduais em real time. Confrontando indicadores e otimizando a velocidade dos processos e agilidade dos serviços públicos.",
      },
      digital_reports: {
        title: "RELATÓRIOS DIGITAIS",
        section_text_1:
          "Reduza custos ao compartilhar informações com seu time, seus constituintes, seus residentes e contribuintes.",
        section_text_2:
          "Através da Hyaia apresente dashboards instantâneos em formato digital.                ",
      },
      performance_dashboard: {
        title: "DASHBOARD DE DESEMPENHO",
        section_text:
          "Com dashboards interativos tenha uma visão geral do rastreamento e gerenciamento do tempo da equipe. Filtre por projeto do fornecedor, equipe ou usuário da equipe.",
      },
      project_status: {
        title: "MONITORAMENTO DE STATUS DO PROJETO",
        section_text:
          "Os gestores de projeto podem usar esse dashboard para rastrear todos os KPIs até a conclusão do projeto: fases concluídas, tempo restante para conclusão.",
      },
    },
  },
  financial_services: {
    title: "A MELHOR OPÇÃO EM BRA PARA SUA INSTITUIÇÃO FINANCEIRA",
    section_text_1:
      "O objetivo de toda empresa é lucrar, alcançar sua visão de valores e realizar sua missão.",
    section_text_2:
      "Atingir metas, garantir receitas e reduzir custos são pilares fundamentais para qualquer instituição financeira.",
    section_text_3:
      "A Hyaia é a melhor escolha para auditoria de processos e regras de negócios, garantindo o aumento de lucro na sua organização.",

    monitor_account: {
      title: "MONITORANDO POR CONTA PRÓPRIA",
      section_text_1:
        "Milhares de clientes significam milhares de processos, regras, situações, aborrecimentos e soluções.",
      section_text_2:
        "Monitorar e acompanhar caso a caso, mais inúmeros processos financeiros, com 100% de eficácia parece inviável, mas com a Hyaia isso é possível.",
    },

    compliance_list: {
      compliance: {
        title: "COMPLIANCE",
        section_text_1:
          "Risco e compliance para instituições financeiras são fundamentos imperdíveis.                ",
        section_text_2:
          "Conciliar balanços, DRE, índices, endividamentos, captação de recursos e convertê-los em relatórios, que garantam a confiança dos acionistas, é um trabalho extremamente cirúrgico e minucioso.",
        section_text_3:
          "Com a Hyaia você gera relatórios e dashboards, em tempo real, sobre toda a cadeia operacional e monetária da sua instituição financeira.",
        section_text_4: "Tenha o melhor em tecnologia de compliance.",
      },

      fraud: {
        title: "FRAUDE",
        section_text_1:
          "Seja interna ou externa, a fraude pode vir de qualquer lugar, e a melhor opção em combate antifraude é uma tecnologia que consiga examinar e monitorar toda a sua organização, com políticas e regras, que previnam ou detectem o mais rápido possível qualquer forma de irregularidade.",
        section_text_2:
          "O melhor em IA contra fraudes está na Hyaia. Seja notificado imediatamente a cada ocorrência suspeita em sua organização.",
      },

      customer_plans: {
        title: "PLANOS DE CLIENTES",
        section_text_1:
          "Garanta os contratos, taxas, produtos e serviços acordados com seus clientes, mantendo-os satisfeitos e eliminando o grau de evasão.",
        section_text_2:
          "Um cliente feliz vale por dois. Marketing boca a boca não tem preço.                ",
      },

      treasury: {
        title: "TESOURARIA",
        section_text_1:
          "Negociações e aplicações de recursos financeiros da sua organização financeira com muito mais assertividade e previsão.",
        section_text_2:
          "Nossos módulos não só garantem o monitoramento e auditoria das regras e processos da sua instituição, como também prevê cenários de risco por meio de tecnologia em Deep Learning.                ",
        section_text_3:
          "Prevenir é melhor do que remediar e os lucros agradecem.                ",
        section_text_4:
          "Não perca a oportunidade e tenha a Hyaia em sua organização financeira.                ",
      },
    },
  },

  publish_and_share: {
    title: "PUBLIQUE, COMPARTILHE & CONTRIBUA",
    section_text:
      "Contribua no seu dashboard através do seu time e clientes com links ao vivo.",
    send_dashboards: {
      title: "ENVIE DASHBOARDS EM REAL TIME ATRAVÉS DE LIVE LINKS",
      section_text:
        "Deixe seus dashboards prontos e adicione uma pessoa ou um time a lista de security do dashboard, eles serão alertados por email imediatamente. A Hyaia possui um sistema de agendamento, no qual você configura para atualizar seus dados e convertê-los em dashboards para espaços regulares ou datas específicas. Seu time pode acessar os dashboards em PDFs, imagens ou Live Link - uma inovação no compartilhamento de dashboards inteiramente interativos.",
    },
    learn_to_share: {
      title: "APRENDA A COMPARTILHAR",
      section_text:
        "Exiba seus dashboards da melhor maneira possível compartilhando-os com seu time, parceiros e clientes.",
    },

    email_list: {
      by_email: {
        title: "POR EMAIL",
        section_text:
          "A Hyaia entrega seus dashboards por e-mail, em anexos nos formatos de PDF, Live Link ou imagem.",
      },
      intranet: {
        title: "VIA INTRANET",
        section_text_1:
          "Adicione suas métricas direto a seus softwares de colaboração interna.",
        section_text_2: "Use links ao vivo como IFRAMES.",
      },
      automatic_reports: {
        title: "RELATÓRIOS AUTOMÁTICOS",
        section_text_1:
          "Deixe seus relatórios configurados e compartilhe seus dashboards para os stakeholders selecionados, de acordo com sua escolha.",
        section_text_2: "Expanda sua produtividade.",
      },
    },
  },

  user_security_and_management: {
    title: "SEGURANÇA & GESTÃO DE USUÁRIOS",
    section_text:
      "Gerencie o acesso e permissões de cada usuário na plataforma e em seus dashboards.",
    protection: {
      title: "PROTEÇÃO DE USUÁRIO E EQUIPE",
      section_text_1:
        "Com a Hyaia, você controla e monitora o acesso do seu time ou gestão de dados, dashboards e relatórios.",
      section_text_2:
        "Organize pessoas em equipes, gerencie seus permissões de acesso para dashboards, regras e processos em nossa área de gerenciamento.",
      section_text_3:
        "Desenvolva usuários para seu time e clientes. Inclua e mantenha seus usuários direto na Hyaia. Importe planilhas completas de seus usuários ou use nossa API na sincronização, como o Active Directory e o LDAP.",
    },
    user_secrty: {
      title: "SEGURANÇA DE USUÁRIO",
      section_text:
        "Por meio de licenças de visualizador ou editor você configura a plataforma, de acordo com o grau de autorização de cada usuário. Desde a visualizações de dashboards, regras, processos e políticas corporativas quanto a edição das mesmas.",
    },

    team_secrty: {
      title: "SEGURANÇA DE EQUIPE",
      section_text:
        "Ordene seus usuários em times e determine direitos de acesso para o grupo inteiro. Migre usuários entre equipes imediatamente, atribuindo diferentes dados e visibilidade de dashboards e regras.",
    },

    user_params: {
      title: "PARÂMETROS DE USUÁRIO E EQUIPE",
      section_text:
        "Através de parâmetros filtre automaticamente as informações de cada dashboard para o usuário, de acordo com as permissões de cada equipe. Os times focam nos insights mais relevantes para eles, sem acesso aos dados de outros usuários.",
    },
  },

  security: {
    title: "SEGURANÇA AVANÇADA",
    section_text:
      "Seus dados protegidos e seguros. A Hyaia não trabalha com nenhum tipo de importação de dados, através de conexões VPN seus dados são lidos, auditados na base, convertidos em relatórios e dashboards.",
    company_info: {
      title:
        "SEGURANÇA AVANÇADA PARA OS DADOS, DASHBOARDS E INFORMAÇÕES DA SUA EMPRESA",
      section_text_1:
        "A proteção dos seus dados e informações é a nossa principal prioridade.",
      section_text_2:
        "Os nossos recursos avançados de segurança você personaliza suas políticas, de acordo com os padrões corporativos do seu negócio. Integrando seu provedor e identidade favoritos.",
      section_text_3:
        "A autenticação é uma das travas de segurança. Nosso time da Central de Confiabilidade empenha-se cada vez mais em garantir que os processos, pessoas e ferramentas permaneçam alinhados com as regulamentações de segurança, como SOC 1, 2 e 3, ISO 27001, e respeito aos regulamentos de privacidade como LGPD, GDPR, HIPAA entre outros.",
    },
    steps: {
      sso: {
        title: "SINGLE SIGN-ON (SSO)",
        section_text:
          "Facilite para que todos os usuários usem o mesmo nome e senha através do Single Sign-On.",
      },
      two_factor: {
        title: "AUTENTICAÇÃO DE 2 FATORES",
        section_text_1:
          "Conecte a Hyaia pelo seu celular e garanta a proteção do seu usuário mediante a autenticação 2FA, você terá o acesso com mais uma camada, além do seu nome e senha.",
        section_text_2: "",
      },
      tracking_session: {
        title: "RASTREAMENTO DE SESSÃO",
        section_text_1:
          "Veja todas as atividades de cada usuário. Observe quando, como e o que cada um está fazendo.",
        section_text_2:
          "Acompanhe o acesso das suas informações por usuário, endereço de IP, data/hora e ação.",
      },
      whitelist: {
        title: "WHITELIST POR IP",
        section_text:
          "O nosso recurso de Whitelist, por IP, permite que apenas determinados endereços de IP consigam acessar seus dashboards ou aplicativos.",
      },
      log_tracing: {
        title: "ANÁLISE DE LOG INTELIGENTE",
        section_text:
          "Analisamos o uso de acesso e bloqueamos automaticamente as contas com falhas de tentativas seguidas ou locais não aprovados por você.",
      },
      password_rules: {
        title: "REGRAS DE SENHA",
        section_text:
          "Senha fortes, inteligentes e complexas, que são alternadas com frequência. Tamanho mínimo de caracteres, letras maiúsculas e minúsculas, símbolos, números e todas as opções.",
      },
    },

    rest_api: {
      title: "UMA API SIMPLES E SEGURA BASEADA EM REST",
      section_text:
        "Simples e poderosas são as APIs da Hyaia. Você que é desenvolvedor vai amar trabalhar com nossa API, criando aplicativos inovadores, interfaces velozes, estendendo sua interface de usuários na inclusão de dashboards. Tudo o que você precisa está na nossa referência de API on-line, até uma área criativa de endpoint.",
    },
  },

  awards: {
    title: "PREMIAÇÕES",
    section_text:
      "Nos comprometemos a oferecer sempre soluções de qualidade e com segurança aos nossos clientes. Por isso, somos reconhecidos como a melhor tecnologia multisetores do mundo em Business Revenue Assurance. E com orgulho listamos nossas premiações:",
  },

  whitelabel: {
    title: "WHITE LABEL DASHBOARDS",
    section_text:
      "Beneficie seus serviços e aplicativos do White Label (OEM) da Hyaia e faça dela parte do seu negócio.",
    dashboard: {
      title: "ADICIONE DASHBOARDS WHITE LABEL ONDE VOCÊ DESEJAR",
      section_text_1:
        "Remova qualquer menção à marca Hyaia e coloque a da sua empresa, com o nosso recurso de White Label.",
      section_text_2:
        "Encante seus clientes e time, com análises diretas do seu aplicativo e site.",
    },
    in_your: {
      crm: {
        title: "NA SUA PLATAFORMA DE CRM",
        section_text:
          "Potencialize seu CRM de vendas e serviços possibilitando que seus usuários contemplem dashboards customizados criados exclusivamente para eles. Forneça a eles mais personalização, flexibilidade e dashboards com um visual atrativo.",
      },
      erp: {
        title: "NA SUA PLATAFORMA DE ERP",
        section_text:
          "O seu ERP não fornece excelentes relatórios? Adicione dashboards customizados com dados do seu ERP, cruzados com outras bases de dados, para ter o melhor do seu sistema.",
      },
      portal: {
        title: "NO SEU PORTAL",
        section_text:
          "Tão fácil quanto copiar e colar, a integração do dashboard da Hyaia é para você que usa SharePoint ou outro software, como solução para seu portal interno.",
      },

      site: {
        title: "NO SEU SITE",
        section_text_1:
          "Precisa de gráficos dinâmicos em seu site? Ou um KPI para seu número de curtidas e visitas?",
        section_text_2:
          "Com a Hyaia, e nossos links ao vivo públicos, dê uma aparência analítica a sua web.",
      },

      views: {
        title: "VISUALIZAÇÕES INCORPORADAS",
        section_text:
          "Incorpore dashboards interativos e dinâmicos diretamente do seu portal ou app da web pelos nossos links, ao vivo, em instantes. Copie e cole nosso código iFrame direto em sua web, e fique pronto para adicionar dashboards em seu aplicativo.",
      },

      app: {
        title: "NA SUA APLICAÇÃO PERSONALIZADA",
        section_text:
          "Você tem um excelente aplicativo B2B na cloud, porém não consegue desenvolver um módulo de relatório ao redor dele?  Tenha a Hyaia adicionada a seu aplicativo, por meio de iFrames e APIs, e deixe seus clientes impressionados com suas apresentações.",
      },
      sso: {
        title: "SINGLE SIGN-ON (SSO)",
        section_text:
          "Através do conector do Active Directory ou integração SAML, facilite muito o tempo de seus usuários, ativando logon único. Use também nossa API na sincronização dos usuários, do seu aplicativo customizado, para Hyaia e vice-versa.",
      },
      two_way: {
        title: "INTERAÇÕES DE VIA DUPLA",
        section_text:
          "Com o seu aplicativo CRM clique em um gráfico, selecione o cliente para visualizar todos os pedidos de vendas do mesmo. A interação de duas vias transmite parâmetros entre os dashboards da Hyaia e seu app.",
      },
    },
  },

  privacy_policy: {
    main_section: {
      first_tilte: "Políticas",
      second_title: "de Privacidade",
      text: "Nós respeitamos seus dados. É nosso negócio garantir que seus dados permaneçam seguros, privados e protegidos. De um visitante do site a um cliente de longo prazo, essa é nossa política de privacidade e cookies.",
    },
    introduction_section: {
      title: "introdução",
      paragraph_1: "Sua privacidade é de suma importância para a Hyaia SAAS.",
      paragraph_2:
        "A Hyaia fornece um serviço baseado em nuvem (o “Serviço”), que é uma plataforma de análise de dados e relatórios para armazenamento, processamento, interface e visualização de dados por meio de nossa plataforma web, API e aplicativos móveis.",
      paragraph_3:
        "Respeitamos totalmente o seu direito à privacidade em relação às suas interações com o Serviço e estamos comprometidos em ser transparentes em nossas negociações com você, sobre quais informações pessoais coletaremos e como usaremos suas informações pessoais.",
      paragraph_4:
        "Além disso, coletamos e usamos somente informações pessoais que são necessárias para fornecer serviços, cujo temos uma base legal para fazê-lo.",
      paragraph_5:
        "Criamos esta Política de Privacidade para descrever nossas práticas e procedimentos no tratamento de “Informações Pessoais” que coletamos ou recebemos de você.",
      paragraph_6:
        "O termo “Informações Pessoais” significa qualquer informação que identifique, relacione, descreva ou seja capaz de estar associada, ou possa estar razoavelmente ligada, direta ou indiretamente, a uma pessoa natural viva identificada ou identificável, incluindo, mas não se limitando a: (i) Identificadores como nome real, pseudônimo, endereço postal, identificador pessoal único, endereço IP, endereço de e-mail, nome da conta e (ii) informações definidas como “informações pessoais”, “informações de identificação pessoal”, “ dados pessoais ”, ou expressões semelhantes ao abrigo das leis de privacidade aplicáveis ou das leis de segurança de dados, que incluem o Regulamento Geral de Proteção de Dados da União Europeia (GDPR) entre outros.",
      paragraph_7:
        "Esta Política de Privacidade abrange três tipos de informações pessoais:",
      list: {
        item_1:
          "“Informações do Site” significa informações coletadas enquanto visualiza páginas em nossos sites, informações que você digitou em nosso contato, download de documentos, formulários de emprego ou outros formulários, URLs de referência e endereço IP e dados semelhantes rastreados internamente e também por terceiros;",
        item_2:
          "“Informações Relacionadas à Conta” significam informações de contato, informações de pagamento e informações biográficas sobre os representantes e contatos de nossos clientes usados para marketing, abrindo novas contas de usuário para usar nossos Serviços e para manter as contas existentes;",
        item_3:
          "“Dados do Conteúdo do Usuário da Conta” são os dados que você ou seus usuários têm permissão para fazer, carregar, conectar, transferir, inserir ou importar na Hyaia para fins de utilização ou Serviço.",
      },
      paragraph_8:
        "Por favor, leia esta Política de Privacidade com cuidado. Solicitaremos seu consentimento em ficar vinculado a esta Política de Privacidade como condição de: (i) visualizar nossos sites e (ii) testar ou utilizar nossos serviços.",
      paragraph_9:
        "Nosso site e nossos serviços são destinados a profissionais e adultos. Nós não recolhemos informações pessoais de usuários com menos de 13 anos de idade, mas disponibilizamos nossos serviços para instituições acadêmicas.",
    },
    colected_data_section: {
      title: "Dados coletados",
      sub_section_1: {
        sub_title: "Cookies do Web Site",
        paragraph_1:
          "Um cookie é um pequeno arquivo colocado em seu navegador que nos permite melhorar sua experiência nos sites e aplicativos Hyaia, lembrando suas preferências e configurações.",
        paragraph_2:
          "Os cookies da Hyaia são usados para armazenar o idioma do site preferido/selecionado, o site que referencia o visitante, um identificador exclusivo que pode ser rastreado até a sessão no aplicativo para relatório de atividades ou para padrões predefinidos, como preferências de região e idioma.",
        paragraph_3:
          "Além disso, nosso site usa o Google Analytics usando o Gerenciador de tags, que rastreia os visitantes, a atividade de página para página e a duração de cada página. Usamos esses cookies para melhorar nosso site em conteúdo e organização e indexá-lo preferencialmente na pesquisa do Google.",
      },
      sub_section_2: {
        sub_title: "Formulários do Website",
        paragraph_1:
          "Os formulários de sites são usados para permitir que os visitantes entrem em contato com a equipe de vendas para perguntas comerciais, solicitações de emprego e para encaminhar solicitações de informações ou documentos adicionais sobre tópicos relacionados.",
      },
      sub_section_3: {
        sub_title: "Dados do proprietário principal da conta",
        paragraph_1:
          "Os usuários que se inscrevem para o estudo e/ou assinaturas pagantes são obrigados a digitar um endereço de e-mail válido, nome e sobrenome, nome comercial e telefone de acordo com os Termos de Uso.",
        paragraph_2:
          "Os usuários que não desejam inserir as informações acima corretamente não estão autorizados a usar nosso Serviço.",
        paragraph_3:
          "Essas informações são coletadas e armazenadas com a conta para fornecer notificações de alterações de serviço e para identificar o proprietário da conta em caso de violação de dados, uso indevido de dados ou outros tópicos relacionados ao uso do Serviço.",
      },

      sub_section_4: {
        sub_title: "Dados do usuário da conta",
        paragraph_1:
          "Os usuários que conectam, enviam ou inseriram dados no Hyaia para análise no decorrer do uso do Serviço almejam total privacidade de seus dados.",
        paragraph_2:
          "A Hyaia adere a uma forte Política de Privacidade para todos os seus funcionários e parceiros. Esta política, em essência, proíbe o acesso a dados sem a permissão expressa do usuário. Essa permissão é registrada e o acesso à conta deles também é registrado e visível para o proprietário da conta.",
        paragraph_3:
          "O conteúdo dos dados não é de responsabilidade da Hyaia, nem somos capazes de interpretar esses dados, suas origens e seu uso. Quando o acesso à conta é fornecido, nossa responsabilidade é ajudar nossos clientes a resolver o problema.",
        paragraph_4:
          "Nós não transmitimos, copiamos ou movemos dados da região original do Data Center para qualquer outra região ou banco de dados. Não permitimos o acesso aos dados, exceto para a equipe de suporte técnico do Microsoft Azure em caso de problemas no sistema ou no banco de dados e sempre supervisionados pela equipe da Hyaia.",
      },

      sub_section_5: {
        sub_title: "Dados de pagamento da conta",
        paragraph_1:
          "O proprietário principal da conta, ao usar nossos serviços pagos, deve adicionar um método de pagamento.",
        paragraph_2:
          "Todos os outros dados, como: nome da empresa, endereço de cobrança, IVA (Imposto sobre Valor Agregado - ou TVA em francês) ou números de identificação fiscal - os identificadores da empresa são necessários para práticas contábeis e usados como tal.",
      },
    },

    data_use_section: {
      title: "USO DE DADOS COLETADOS",
      paragraph_1:
        "Os dados coletados no site são usados para otimizá-lo, alterando a estrutura e o conteúdo.",
      paragraph_2:
        "Dados de formulários, como Fale Conosco, Emprego, Visão e Roteiro, Registro de Blog, Ativos de Download, como Whitepapers e Documentos, são usados para fornecer as informações necessárias ao solicitante.",
      paragraph_3:
        "Os dados dos usuários da conta são usados para enviar boletins de produtos, notificações do sistema, alertas, publicações conforme agendadas pelos usuários ou pelo sistema, conforme necessário, mas não exclusivo para redefinir senha, limites do sistema, pagamento e faturas, lançamentos de novos produtos, atualizações ou inatividade, alertas de segurança e alertas semelhantes.",
    },

    gdpr_section: {
      title: "GDPR",
      paragraph_1:
        "Se você for uma pessoa na Área Econômica Européia, poderá ter os seguintes direitos sob a lei de proteção de dados, de proteção de dados aplicável e nós, como Controlador de Dados em relação a Informações Relacionadas à Conta ou outras Informações Pessoais cobertas por esta Política de Privacidade, com tais direitos em relação a tais Informações Pessoais:",
      list: {
        item_1:
          "o direito de acesso à Informações Pessoais relacionadas a você;",
        item_2:
          "o direito de corrigir quaisquer erros em suas Informações Pessoais;",
        item_3:
          "o direito de se opor e nos pedir para parar de entrar em contato com você com marketing direto;",
        item_4: "direitos em relação ao processamento automatizado de dados;",
        item_5:
          "o direito de restringir ou impedir que suas informações pessoais sejam processadas;",
        item_6:
          "o direito de ter suas informações pessoais portadas para outro controlador de dados;",
        item_7: "o direito de apagar;",
        item_8:
          "o direito de reclamar com a DPC se você acreditar que não tenhamos manipulado suas Informações Pessoais, de acordo com a lei de Proteção de Dados Aplicável.",
      },
      paragraph_2:
        "Se você for um usuário trabalhando em nome de um cliente Hyaia existente e tivermos suas informações relacionadas à conta, sob um contrato com esse cliente, teremos interesse legítimo em enviar comunicações eletrônicas/marketing direto relacionadas ao Serviço e assuntos relacionados (que pode incluir, mas não se limitará a boletins informativos, anúncio de novos recursos etc.).",
      paragraph_3:
        "Também podemos fazer perguntas para diferentes Serviços, incluindo concorrência. E poderemos solicitar a você que conclua pesquisas que utilizamos para fins de pesquisa, embora você não precise respondê-las. É possível solicitar que paremos de entrar em contato com você para fins de marketing direto.",
      paragraph_4:
        "Se você gostaria de fazer isso, envie um e-mail diretamente para support@hyaia.com ou ligue para um dos números disponíveis no site. Você também pode clicar no botão “Cancelar Inscrição” na parte inferior da comunicação eletrônica.",
      paragraph_5:
        "Pode levar até quinze (15) dias para que isso ocorra; e deixe-nos saber o método de contato com o qual você não está satisfeito. E se está insatisfeito com determinadas formas de entrar em contato com você (por exemplo, você pode ficar feliz que entrem em contato por e-mail, mas não por telefone).",
    },

    protector_structure_section: {
      title: "ESTRUTURA DO PROTETOR DE PRIVACIDADE UE-EUA",
      paragraph_1:
        "Como você tem a opção de armazenar os dados em um data center na UE ou nos EUA, não aderimos à EU-U.S. Privacy Shield, pois não se aplica. Seus dados, se você armazená-lo na UE, permanecerão na UE.",
    },

    retention_section: {
      title: "RETENCAO DE DADOS",
      paragraph_1:
        "Informações Relacionadas à Conta e outras Informações Pessoais serão mantidas e armazenadas por um período de tempo conforme julgarmos necessário, levando em conta o propósito comercial para o qual foi coletada em primeira instância (ou seja, a administração da Sua Conta enquanto sua Conta está ativa e um período razoável depois disso, caso decida reativar a sua conta), e as nossas obrigações ao abrigo da lei aplicável de proteção de dados.",
      paragraph_2:
        "Isso pode incluir a retenção de Informações Relacionadas à Conta ou outras Informações Pessoais conforme necessário para cumprir com nossas obrigações legais, para resolver disputas, fazer cumprir nossos contratos, apoiar operações comerciais e continuar a desenvolver e melhorar nossos Serviços.",
      paragraph_3:
        "Onde mantemos o aprimoramento e o desenvolvimento de informações pessoais para serviços, tomamos medidas para eliminar informações que o identificam diretamente, e usamos apenas as informações para descobrir insights coletivos sobre o uso de nosso Serviço, não para analisar especificamente as características pessoais sobre você.",
    },

    contact_section: {
      title: "ENTRANDO EM CONTATO",
      paragraph_1:
        "Se você precisar entrar em contato conosco em relação a qualquer um dos seus direitos conforme estabelecido nesta Política, todos esses pedidos deverão ser feitos por escrito e por e-mail para support@hyaia.com.",
    },

    resolution_section: {
      title: "RESOLUCAO DE DISPUTAS",
      paragraph_1:
        "Se você acha que não processamos suas informações pessoais de acordo com esta Política de Privacidade, entre em contato conosco em primeira instância. Você pode enviar uma reclamação para nós em support@hyaia.com.",
      paragraph_2:
        "Assim que recebermos uma reclamação de privacidade, nossa equipe de privacidade investigará sua reclamação e fornecerá uma resposta.",
      paragraph_3:
        "Precisaremos de informações suficientes para que possamos avaliar sua reclamação e, como resultado, poderemos solicitar que você nos forneça informações adicionais que consideramos necessárias para avaliar sua reclamação.",
      paragraph_4: "O processo de resolução de disputas será em inglês.",
    },

    alterations_section: {
      title: "ALTERAÇÕES À POLÍTICA DE PRIVACIDADE",
      paragraph_1:
        "A Hyaia poderá alterar sua Política de Privacidade de tempos em tempos e a seu exclusivo critério. A data das revisões mais recentes aparecerá nesta página.",
      paragraph_2:
        "Se você não concordar com essas mudanças, por favor, não continue a usar o Serviço, para nos enviar informações relacionadas à conta ou outras informações pessoais.",
      paragraph_3:
        "Se forem feitas alterações materiais à Política de Privacidade, nós o notificaremos colocando um aviso destacado em nosso site ou enviando uma notificação em relação a isso.",
      paragraph_4:
        "Não processaremos informações relacionadas à conta de maneira não contemplada por esta Política de Privacidade sem o seu consentimento.",
    },

    original_section: {
      title: "POLÍTICAS DE PRIVACIDADE ORIGINAL",
      paragraph_1:
        "Este documento em Português é de livre tradução e não se sobrepõe ao documento original, usado apenas com finalidade de apoiar o entendimento de nossos clientes. Dúvidas sobre estas políticas devem ser dirigidas ao e-mail support@hyaia.com.",
    },
  },

  terms_of_use: {
    main_section: {
      first_tilte: "Termos",
      second_title: "de Uso",
      paragraph_1:
        "Os termos de uso do nosso serviço estão descritos nesse documento, nossas obrigações e se caso você aceite usar nossa plataforma, como teste ou como cliente.",
      paragraph_2:
        "É de suma importância que você leia-os e deixe-nos saber quais são as suas dúvidas e preocupações.",
    },
    terms_section: {
      title: "Termos",
      paragraph_1:
        "Estes termos de uso (“Termos”) cobrem o seu uso (“você” e “Cliente”) e acesso aos nossos serviços, software do cliente e sites (coletivamente como “Serviços”) a partir de 1º de janeiro de 2020.",
      paragraph_2:
        "Ao aceitar estes Termos, seja registrando-se em nossos sites, registrando-se para uma avaliação gratuita ou comprando uma de nossas assinaturas, clicando em uma caixa indicando sua aceitação ou executando um formulário de pedido ou qualquer outra documentação que referencia este contrato, você concorda com os termos deste contrato.",
      paragraph_3:
        "Se você está firmando este contrato em nome de uma empresa ou outra entidade legal, você declara que tem autoridade para vincular tal entidade e suas afiliadas a estes termos e condições, caso em que os termos “você” ou “seu” referem-se a tal entidade e suas afiliadas.",
      paragraph_4:
        "Se você não tem essa autoridade ou se você não concorda com estes termos e condições, você não deve aceitar este acordo e não poderá usar nossos Serviços.",
      paragraph_5: {
        first_text: "Nossa ",
        link_text: "Política de Privacidade",
        second_text:
          " explica como coletamos e usamos suas informações ao usar nossos Serviços. Ao utilizar os nossos Serviços, você concorda em estar vinculado a estes Termos e à nossa Política de Privacidade.",
      },
      paragraph_6:
        "Nosso Contrato de Processamento de Dados (DPA) é uma extensão dos Termos, e explica nossa função como Processador de Dados, nossas obrigações e responsabilidades mútuas. Ao usar nossos Serviços, você concorda em estar vinculado a estes Termos e ao DPA.",
    },
    update_use_terms_section: {
      title: "ATUALIZAÇÕES DOS TERMOS DE USO",
      paragraph_1:
        "A Hyaia se reserva o direito de atualizar e alterar os Termos de Uso a qualquer momento e sem aviso prévio.",
      paragraph_2:
        "Todos os novos recursos que aumentam ou aprimoram o Serviço atual, incluindo o lançamento de novas ferramentas e recursos, estarão sujeitos aos Termos de Uso. O uso continuado do Serviço após tais alterações constituirá seu consentimento para tais mudanças.",
      paragraph_3:
        "Os Termos de Uso estabelecem todo o entendimento entre você e a Hyaia em relação ao Serviço, e substituem quaisquer contratos anteriores entre as partes (incluindo, mas não se limitando, a versões anteriores dos Termos de Serviço).",
    },
    services_section: {
      title: "Serviços",
      paragraph_1: "Nossos serviços permitem que o cliente:",
      list: {
        item_1:
          "armazene dados que você escolher transferir para nossos bancos de dados e servidores;",
        item_2:
          "edite, transforme, combine, modifique dados para criar visualizações ou dados adicionais;",
        item_3: "crie relatórios e dashboards dos dados fornecidos;",
        item_4:
          "publique os relatórios e dashboards junto com os dados para outros usuários ou o público.",
      },
      paragraph_2:
        "Podemos remover, suspender temporariamente, modificar e adicionar todo e qualquer serviço sem aviso prévio.",
      paragraph_3:
        "Seu uso do Serviço, incluindo qualquer conteúdo, informação ou funcionalidade contido nele, será fornecido “como está” e “conforme disponível”, sem representações ou garantias de qualquer tipo, expressas ou implícitas, incluindo, mas não se limitando, às garantias implícitas de comerciabilidade, adequação a uma finalidade específica e não-violação. Você assume total responsabilidade e risco pelo uso deste Serviço.",
      paragraph_4:
        "Nossos Serviços permitem o arquivamento ou a remoção de dados em determinados intervalos de tempo e dependendo do nível de assinatura. A Hyaia não é responsável por qualquer perda de dados e nem deve ser considerado um backup para dados críticos.",
      paragraph_5:
        "Nossos Serviços incluem recursos que permitem conexão a dados, sites, aplicativos e serviços de terceiros. A Hyaia não se responsabiliza pelo uso dos produtos fornecidos por terceiros, e nem será afiliado a nenhum dos terceiros.",
      paragraph_6:
        "Você pode selecionar diferentes tipos de assinaturas e cada um pode ter recursos e funcionalidades diferentes que podem mudar com o tempo.",
      sub_section_1: {
        title: "a) Assinaturas pessoais, gratuitas e de avaliação",
        paragraph_1:
          "A Hyaia pode oferecer assinaturas que permitem o uso limitado do Serviço em funcionalidade ou duração. Os usuários dessas assinaturas podem estar sujeitos a publicidade, funcionalidade limitada e redução de Serviços e/ou limites na capacidade de dados.",
        paragraph_2:
          "Essas assinaturas podem ser removidas para liberar espaço para outras contas, se não forem usadas ativamente durante um certo período de tempo.",
        paragraph_3:
          "Essas assinaturas podem ser canceladas a qualquer momento e sem aviso se esses Termos forem violados.",
      },
      sub_section_2: {
        title:
          "b) Assinaturas sem fins lucrativos ou apenas para uso acadêmico",
        paragraph_1:
          "A Hyaia pode oferecer assinaturas gratuitamente ou a um custo reduzido, o que permite o uso acadêmico e sem fins lucrativos de nossos Serviços com funcionalidade limitada.",
        paragraph_2:
          "Os usuários desta assinatura podem estar sujeitos a publicidade, funcionalidade limitada e redução de serviços e/ou limites na capacidade de dados, a menos que haja componentes pagadores de suas assinaturas.",
        paragraph_3:
          "Esses modelos de contas podem ser removidos para liberar espaço para outras contas, caso não sejam usadas ativamente por um determinado período de tempo.",
      },
      sub_section_3: {
        title: "c) Assinaturas pagas",
        paragraph_1:
          "A Hyaia oferece serviços pagos que permitem o uso do Serviço. Os usuários deste Serviço terão recursos diferenciados, dependendo do nível de assinatura.",
        paragraph_2:
          "Existem vários níveis de serviço, dependendo do grau e do acordo entre o Cliente e o Hyaia. Em geral, os níveis mais básicos têm menor desempenho, armazenamento e capacidade do que os níveis mais elevados, no entanto, eles podem mudar com o tempo e podem ser substituídos ou modificados caso a caso.",
      },
      sub_section_4: {
        title: "d) Funcionalidade adotada de forma antecipada",
        paragraph_1:
          "Às vezes, lançamos produtos e recursos que ainda estão em testes e sendo avaliados. Esses Serviços serão marcados como beta, pré-visualização, acesso antecipado ou avaliação (ou com palavras ou frases com significados semelhantes) e podem não ser tão confiáveis quanto outros serviços. Por favor, use-os por sua conta e risco.",
      },
    },
    software_section: {
      title: "SOFTWARE",
      paragraph_1:
        "Alguns de nossos Serviços permitem que você baixe o software do cliente (“Software”), que pode ser atualizado automaticamente. Contanto que cumpra estes Termos, nós damos a você uma licença limitada, não-exclusiva, intransferível e revogável para usar o Software, exclusivamente para acessar os Serviços.",
      paragraph_2:
        "Na medida em que qualquer componente do Software possa ser oferecido sob uma licença de código aberto, disponibilizamos essa licença para você e as disposições desta licença poderão substituir expressamente alguns desses Termos.",
      paragraph_3:
        "A menos que as seguintes restrições sejam proibidas por Lei, você concorda em não fazer engenharia reversa ou descompilar os Serviços, tentar fazê-lo ou auxiliar alguém a fazê-lo.",
    },
    content_section: {
      title: "Conteúdo",
      paragraph_1:
        "Quando usar nossos Serviços, você pode armazenar arquivos e dados, bem como metadados (“Conteúdo”). Estes Termos não nos dão o direito de acessar, usar ou distribuir o seu Conteúdo, a menos que seja necessário fornecer o Serviço.",
      paragraph_2:
        "Nossos Serviços também fornecem recursos como pesquisa, detecção de metadados ou vinculação. Esses e outros recursos podem exigir que nossos sistemas acessem, armazenem e digitalizem o Conteúdo.",
      paragraph_3:
        "Você nos dá permissão para realizar os processos, e essa permissão se estende a nossos afiliados e terceiros confiáveis com quem trabalhamos.",
      paragraph_4:
        "Nossos Serviços permitem que compartilhe seu conteúdo com outras pessoas por meio de dashboards e dados pelos Live Links e recursos semelhantes. Não publicamos em seu nome e nem controlamos os destinatários do seu conteúdo.",
    },
    use_section: {
      title: "USO ACEITÁVEL",
      paragraph_1:
        "O seguinte descreve ações que constituem um uso não aceitável de nosso Serviço e resultarão no cancelamento e na remoção imediata de sua conta e todo o seu conteúdo de nosso Serviço sem aviso, notificação, reembolso ou crédito por quaisquer valores já pagos:",
      list: {
        item_1:
          "Usar os Serviços para incentivar atividades ilegais, abusivas ou outras que interfiram nos negócios ou atividades da Hyaia e/ou de outros clientes;",
        item_2:
          "Tentativa de ignorar ou interromper qualquer mecanismo de segurança em qualquer um dos Serviços ou usar os Serviços de uma maneira que represente um risco de segurança ou de serviço para a Hyaia ou a um de seus usuários;",
        item_3:
          "Fazer engenharia reversa dos Serviços para encontrar limitações, vulnerabilidades ou evitar os recursos de filtragem;",
        item_4:
          "Usar os Serviços de maneira que possa sujeitar a Hyaia ou a terceiros a responsabilidades, danos ou perigos;",
        item_5:
          "Lançar ou facilitar, intencionalmente ou não, um ataque de negação de serviço em qualquer um dos Serviços ou qualquer outra conduta que afete negativamente a disponibilidade, a confiabilidade ou a estabilidade dos Serviços;",
        item_6:
          "Transmitir qualquer material que contenha vírus, “Cavalo de Tróia”, worms ou outros programas maliciosos, prejudiciais ou perigosos;",
        item_7:
          "Usando os Serviços para participar ou se conectar com atividades fraudulentas;",
        item_8:
          "Usar os Serviços contrariamente a qualquer política de privacidade, incluindo mas não limitado a HIPAA, PIPEDA e GDPR;",
        item_9:
          "Violar ou facilitar a violação de qualquer lei ou regulamento local, regional, provincial, estadual, federal ou estrangeira, incluindo leis e regulamentos relativos à transmissão de dados ou software;",
        item_10:
          "Tomar qualquer medida para participar, incentivar ou promover qualquer atividade proibida nos termos deste Termos de Uso;",
        item_11:
          "Usar o Serviço para enviar e-mails em massa ou spam a terceiros sem o seu consentimento ou não de acordo com o CAN-SPAM e guias similares;",
        item_12:
          "Utilizar os Serviços para armazenar ou transmitir qualquer material que infrinja os direitos de propriedade intelectual ou outros direitos de terceiros;",
        item_13:
          "Usar os Serviços para armazenar ou transmitir qualquer material que seja libidinoso, difamatório, discriminatório ou malicioso ou prejudicial a qualquer pessoa ou entidade;",
        item_14:
          "Utilizar os Serviços ou qualquer componente dos Serviços, de forma não autorizada pela Hyaia;",
        item_15:
          "Representar outros usuários sem permissão ou acessar qualquer área da plataforma que não tenha permissão para acessar.",
      },
      paragraph_2:
        "Você e sua empresa são responsáveis por sua conduta e conteúdo e você deve cumprir todos os termos de uso aceitáveis acima.",
      paragraph_3:
        "Podemos rever sua conduta e conteúdo para conformidade com estes Termos. Com isso dito, não temos obrigação de fazê-lo.",
      paragraph_4:
        "Proteja sua senha para os Serviços, certifique-se de que outras pessoas não tenham acesso a ela e mantenha as informações da sua conta atualizadas.",
      paragraph_5:
        "Finalmente, nossos Serviços não são destinados e não podem ser usados por pessoas menores de 13 anos. Ao usar nossos Serviços, você está representando para nós que é maior de 13 anos.",
    },
    communication_section: {
      title: "Comunicação",
      paragraph_1:
        "Você deve fornecer seu nome completo, um endereço de e-mail válido e outras informações, conforme necessário, para concluir o processo de inscrição e ativação. Endereços de e-mail inválidos, nomes ou informações da empresa não são um uso aceitável dos Serviços.",
      paragraph_2:
        "Independentemente da nossa Política de Privacidade, e para fornecer o Serviço a você, a Hyaia poderá se comunicar com você via e-mail ou telefone com relação à sua conta, atualizações, notícias e outros assuntos relacionados à sua conta. Por favor, consulte a nossa Política de Privacidade para obter informações adicionais.",
      paragraph_3:
        "Você é responsável por manter a segurança de sua conta e senha. Hyaia nunca solicitará sua senha nem fornecerá sua senha via e-mail ou qualquer outro meio de comunicação.",
    },
    host_section: {
      title: "Hospedagem",
      paragraph_1:
        "Você entende que a Hyaia usa fornecedores terceirizados e parceiros de hospedagem para fornecer o hardware, software, informações, rede, armazenamento e tecnologia relacionadas necessárias para executar o serviço.",
      paragraph_2:
        "Nossos serviços são hospedados ou contam com os seguintes provedores:",
      list: {
        item_1:
          "Microsoft Corporation One Microsoft Way Redmond, WA 98052-7329 USA",
        item_2: "OVH 2 Rue Kellermann 59100 Roubaix France",
      },
    },
    service_availability_section: {
      title: "Disponibilidade do Serviço",
      paragraph_1:
        "A Hyaia esforçar-se-á por disponibilizar o Serviço 99,5% do ano, mas não garante, a menos que seja documentado de outra forma através de um contrato de Cliente Empresarial que anule estes Termos.",
      paragraph_2:
        "A Hyaia não será responsável por qualquer perda de dados, negócios, receita ou propriedade devido à falta de disponibilidade do Serviço. ",
      paragraph_3:
        "Falhas inesperadas causadas por terceiros, incluindo Microsoft Azure, OVH, Amazon e Google, usadas por nossa infraestrutura, bem como qualquer software ou serviço que nos conectamos não contam para nossas métricas de disponibilidade de Serviço.",
      paragraph_4:
        "Mediante solicitação, poderemos fornecer, a nosso critério, mais detalhes sobre a interrupção do Serviço, na forma de um Relatório de Interrupção do Serviço (Service Interruption Report - SIR). Um SIR pode ser emitido de maneira limitada ou não conter informações de segurança e/ou proprietárias.",
    },
    support_service_section: {
      title: "Suporte ao Serviço",
      paragraph_1:
        "A Hyaia se esforça para fornecer suporte a todos os Clientes, dentro de um período de tempo aceitável, mas não garante isso, a menos que seja documentado de outra forma por meio de um contrato específico do Acordo de Nível de Serviço, sobrepondo-se a todas ou partes dos Termos.",
    },
    clossing_section: {
      title: "Encerramento",
      paragraph_1:
        "Você está livre para parar de usar nossos serviços a qualquer momento. Também nos reservamos o direito de suspender ou encerrar os Serviços a qualquer momento, a nosso critério e sem aviso prévio.",
      paragraph_2:
        "Por exemplo, podemos suspender ou encerrar seu uso dos Serviços se você não estiver cumprindo estes Termos ou usar os Serviços de uma maneira que possa nos causar responsabilidade legal, interromper os Serviços ou interromper o uso dos Serviços por terceiros.",
      paragraph_3:
        "Exceto para assinaturas pagas, nos reservamos o direito de encerrar e excluir sua conta se você não estiver acessando nossos Serviços, após um determinado período de tempo.",
      paragraph_4:
        "Hyaia irá fornecer-lhe um aviso através do endereço de e-mail associado à sua conta antes de o fazermos. Nós não somos responsáveis pela recepção adequada do e-mail devido a spam, regras, firewall ou desabilitar notificações.",
      paragraph_5:
        "Reservamo-nos o direito de aceitar ou recusar um cliente. Temos a discrição exclusiva sobre permitir ou não o cadastro, renovação, alteração de plano ou uso de nossos serviços.",
      paragraph_6:
        "Para cancelar uma conta, você deve entrar em contato diretamente com a equipe da Hyaia por e-mail ou telefone. Por favor, use o endereço de e-mail support@hyaia.com para cancelar sua conta.",
      paragraph_7:
        "Sua assinatura paga permanecerá em vigor até (i) ser cancelada, ou (ii) ser rescindida sob estes Termos ou (iii) o pagamento não ser efetuado ao final de cada ciclo de renovação de pagamento.",
      paragraph_8:
        "O cancelamento da sua conta é imediato e resultará em perda permanente de seus dados.",
      paragraph_9:
        "O Hyaia não poderá restaurar a conta após um determinado período de tempo e nem recuperar nenhum de seus dados. Nenhum crédito ou reembolso será feito no caso de um cancelamento iniciado pelo Cliente, antes do final do período de faturamento / período de assinatura.",
    },
    downgrade_section: {
      title: "Downgrade",
      paragraph_1:
        "Algumas assinaturas podem ser desatualizadas para uma camada inferior, desde que a assinatura não exceda os limites de uso ou os recursos disponíveis, apenas o nível de assinatura utilizada. As assinaturas que não atenderem aos requisitos do novo grau de assinatura de destino permanecerão na assinatura atual.",
      paragraph_2:
        "Não é responsabilidade da Hyaia garantir que os requisitos sejam atendidos antes de alterar a assinatura. Os registros devem ser modificados antes do final do ciclo de faturamento, e entrarão em vigor imediatamente no momento da modificação.",
      paragraph_3:
        "Nenhum reembolso ou crédito será concedido para assinaturas que permanecerem em seu nível de assinatura, se caso exceder os limites de uso do nível de assinatura desejado.",
      paragraph_4:
        "Nenhum reembolso ou crédito será concedido para recursos pré-pagos não utilizados ou limites adicionados ao nível de assinatura inicial. Dados e funcionalidades podem ocorrer durante o downgrade de subscrições, por isso tenha cuidado antes de fazer downgrade.",
      paragraph_5:
        "Alguns níveis de inscrição não podem sofrer downgrade, apenas cancelados.",
    },
    upgrade_section: {
      title: "Upgrade",
      paragraph_1:
        "O acréscimo de opções ou atualizações que causam um aumento nas tarifas será cobrado em seu cartão de crédito e entra em vigor imediatamente. Nem todos os níveis de assinaturas podem ser atualizados ou podem ter suas opções modificadas.",
    },
    prices_section: {
      title: "PREÇOS E PAGAMENTO",
      paragraph_1:
        "Os preços de todos os Serviços, incluindo, entre outros, as taxas do plano de assinatura do Serviço, estão sujeitos a alterações sem aviso prévio. Tendo dito o acima, vamos tentar notificar todos os clientes pelo menos trinta (30) dias antes via e-mail.",
      paragraph_2:
        "Os métodos de pagamento aceitáveis são por transferência bancária, cartão de crédito ou PayPal. Pagamento por cheque bancário de acordo por ambas as partes apenas.",
      paragraph_3:
        "Todos os outros métodos de pagamento serão recusados e não constituem pagamento. Se pagar com cartão de crédito ou PayPal e, dependendo da sua localização, o pagamento será efetuado por um processador de pagamentos dos EUA ou por um processador de pagamentos europeu.",
      paragraph_4:
        "Você é responsável por todos os impostos aplicáveis, taxas bancárias, taxas de transferência, taxas de cartão de crédito, taxas de câmbio, impostos federais, regionais, estaduais, locais ou quaisquer sobretaxas e prorrogações semelhantes impostas ou relacionadas aos nossos Serviços.",
      paragraph_5:
        "Para os propósitos desta seção, os impostos não incluem impostos que sejam obrigatórios ou mensurados pelo imposto sobre a renda, imposto sobre a propriedade ou imposto sobre a folha de pagamento da Hyaia. Você deve nos notificar por escrito se contestar qualquer parte de quaisquer taxas pagas ou pagáveis por você. Sob este acordo.",
      paragraph_6:
        "Você deve nos fornecer essa notificação por escrito dentro de sessenta (60) dias da taxa aplicável e trabalharemos junto com você para resolver a disputa aplicável imediatamente.",
      paragraph_7:
        "Se você não nos fornecer este aviso por escrito de sua disputa de taxas dentro deste período, você não terá o direito de contestar quaisquer taxas pagas ou pagáveis por você.",
      paragraph_8:
        "Se seu uso de nossos Serviços exceder os valores pré-pagos por você ou se você falhar para pagar quaisquer valores devidos por você, poderemos suspender nossos Serviços associados à sua conta sem aviso prévio.",
      paragraph_9:
        "Nós não teremos nenhuma responsabilidade por quaisquer danos, responsabilidades, perdas (incluindo qualquer perda de dados ou lucros) ou quaisquer outras consequências que você possa incorrer com conexão com qualquer suspensão de nossos serviços nos termos desta seção.",
      paragraph_10:
        "Se as taxas de serviço não forem pagas em tempo hábil ou se não conseguirmos processar sua transação, usando as informações de cartão de crédito fornecidas ou usando um método de pagamento alternativo, reservamos o direito de revogar o acesso à sua conta ou fazer o downgrade de sua conta para uma conta gratuita o que pode resultar em perda de dados e/ou recursos.",
    },
    copyrigth_section: {
      title: "COPYRIGHT E PROPRIEDADE",
      paragraph_1:
        "A Hyaia possui os direitos de propriedade intelectual de todos os componentes protegidos do Serviço, incluindo, entre outros, o nome do Serviço, a arte final e os elementos da interface do usuário final contidos no Serviço, muitos dos recursos individuais e a documentação relacionada.",
      paragraph_2:
        "Congratulamo-nos com o seu feedback sobre nossos serviços, no entanto, enviando sugestões ou outros comentários sobre nossos serviços (“Contribuições”), você concorda que:",
      list: {
        item_1:
          "não temos nenhuma obrigação de confidencialidade em relação às suas Contribuições;",
        item_2:
          "podemos usar ou divulgar (ou optar por não usar ou divulgar) suas Contribuições para qualquer finalidade e de qualquer forma;",
        item_3:
          "você, irrevogavelmente, não exclusivamente, concede a nós direitos para explorar suas Contribuições;",
        item_4:
          "você não tem direito a qualquer compensação ou reembolso de qualquer tipo de nós sob quaisquer circunstâncias por suas Contribuições.",
      },
      paragraph_3:
        "Você não pode copiar, modificar, adaptar, reproduzir, distribuir, fazer engenharia reversa, descompilar ou desmontar qualquer aspecto do Serviço.",
      paragraph_4:
        "A Hyaia não reivindica direitos de propriedade intelectual sobre o Conteúdo que você envia ou fornece ao Serviço.",
    },
    brands_section: {
      title: "MARCAS E LOGOTIPOS",
      paragraph_1:
        "Sujeito a estes Termos, nós concedemos um ao outro o direito de usar e exibir o nome e o logotipo um do outro (as Marcas do Licenciador) em nossos respectivos sites e em outros materiais promocionais unicamente em conexão com cada uma de nossas respectivas atividades sob estes Termos.",
      paragraph_2:
        "Todo esse uso das Marcas do Licenciador estará de acordo com as diretrizes de uso aplicáveis de cada um e garantirá o benefício do Licenciante.",
      paragraph_3:
        "Qualquer um de nós, usando as Marcas de Licenciador da outra sob esta subseção não usará, registrará ou tomará outra ação com relação a qualquer uma das Marcas de Licenciante, exceto na medida permitida antecipadamente por escrito por um de nós, cujas Marcas de Licenciante estão sendo usadas.",
      paragraph_4:
        "Ao usar as Marcas de Licenciador sob esta subseção, um de nós usando as Marcas de Licenciante da outra sempre usará as Marcas de Licenciador atuais e não adicionará, excluirá ou modificará nenhuma das Marcas de Licenciante.",
      paragraph_5:
        "Nenhum de nós usando as Marcas de Licenciante da outra pessoa não poderá, a qualquer momento, representar erroneamente a relação entre nós.",
      paragraph_6:
        "Aquele que usar as Marcas de Licenciante da outra pessoa não se apresentará como afiliado ou outro agente legal de um de nós cujas Marcas de Licenciante estão sendo usadas.",
      paragraph_7:
        "Os direitos de usar e exibir as Marcas de Licenciante uns dos outros sob esta sujeição terminarão automaticamente no caso destes Termos terminarem ou se uma das partes solicitar a remoção do nome e logotipos de sites ou materiais promocionais.",
    },
    confidentiality_section: {
      title: "Confidencialidade",
      paragraph_1:
        "Informação Confidencial significa qualquer informação ou dados, independentemente de estarem em forma tangível, divulgados por qualquer uma das partes que esteja marcada ou designada como confidencial ou proprietária ou que de outra forma possa ser razoavelmente entendida como confidencial, dada a natureza da informação e as circunstâncias divulgação circundante.",
      paragraph_2:
        "“Informações Confidenciais” não incluem nenhuma informação que:",
      list: {
        item_1: "está publicamente disponível sem culpa da parte receptora;",
        item_2:
          "foi devidamente conhecido da parte receptora, sem restrição, antes da divulgação pela parte divulgadora;",
        item_3:
          "foi devidamente divulgado à parte receptora, sem restrição, por outra pessoa sem violar os direitos da parte divulgadora;",
        item_4:
          "é desenvolvida independentemente pela parte receptora sem uso ou referência às informações confidenciais da parte divulgadora.",
      },
      paragraph_3:
        "Cada parte concorda que usará as Informações Confidenciais da outra parte exclusivamente de acordo com as cláusulas deste Contrato, e não divulgará tais informações a terceiros sem o consentimento prévio por escrito da outra parte, exceto se de outra forma permitido neste documento.",
      paragraph_4:
        "Cada parte concorda em exercer o devido cuidado na proteção das Informações Confidenciais contra uso e divulgação não autorizados.",
      paragraph_5:
        "Cada parte pode divulgar as Informações Confidenciais da outra parte, no todo ou em parte, a seus funcionários, representantes, investidores reais ou potenciais e subcontratados que tenham necessidade de saber e estejam legalmente obrigados a manter tais informações confidenciais de acordo com os termos deste documento.",
      paragraph_6:
        "Qualquer uma das partes pode divulgar as Informações Confidenciais da outra parte conforme exigido por lei, mediante notificação prévia por escrito à outra parte (quando permitido por lei), desde que tal parte faça uso de seus esforços razoáveis para minimizar tal divulgação na medida permitida pela legislação aplicável.",
    },
    warranty_section: {
      title: "GARANTIA LIMITADA / LIMITAÇÃO DE RESPONSABILIDADE",
      paragraph_1:
        "Os serviços são fornecidos “como estão” e como disponíveis. A Hyaia não oferece garantias expressas ou implícitas de qualquer tipo, incluindo, sem limitação, garantias implícitas de comercialização ou adequação a uma finalidade específica.",
      paragraph_2:
        "Nenhuma comunicação entre o cliente e a Hyaia, por escrito ou oral, criará uma garantia ou de qualquer forma alterará ou restringirá qualquer isenção de garantia ou limitação de responsabilidade estabelecida nesta seção, ou em qualquer outro lugar deste contrato.",
      paragraph_3:
        "Em nenhuma circunstância a Hyaia será responsável por perda de lucros ou outros danos indiretos, especiais, de cobertura, exemplares, incidentes ou consequências decorrentes ou relacionados a este contrato ou ao uso ou incapacidade de usar o Serviço.",
      paragraph_4:
        "Em nenhuma circunstância a responsabilidade da Hyaia por danos, perdas ou causas de ação, seja em contrato ou delito, conjunta ou separadamente, excederá o valor total em dólar pago pelo cliente à Hyaia durante os 12 (doze) meses anteriores ao dano alegado ou danificar.",
      paragraph_5:
        "As limitações de responsabilidade aqui descritas e na subseção (b) abaixo aplicam-se igualmente à responsabilidade por negligência:",
      list: {
        item_1:
          "Sem limitar a generalidade do acima, a Hyaia não terá nenhuma responsabilidade por quaisquer reclamações ou perdas resultantes de violações de segurança, exposição de dados confidenciais ou privados (exceto na medida em que a lei aplicável proíba a limitação de tal responsabilidade) ou perda de dados ou acesso aos dados.",
        item_2:
          "A Hyaia não é responsável pela exatidão, veracidade ou validade de quaisquer dados inseridos pelo Cliente ou fornecidos através do Serviço.",
        item_3:
          "A Hyaia não será responsável pela interrupção ou atrasos na transmissão do Serviço causados por atos de Deus, terrorismo, incêndio, água, tumultos, atos do Governo, atos ou omissões de provedores de backbone da Internet ou quaisquer outras causas além do controle da Hyaia.",
        item_4:
          "O único e exclusivo recurso do Cliente, se estiver insatisfeito com o Serviço ou com quaisquer termos, condições, regras, políticas, diretrizes e práticas da Hyaia é descontinuar o uso do Serviço.",
        item_5:
          "O Cliente reconhece e concorda que a Hyaia definiu seus preços e celebrou este Contrato com base nas limitações e exclusões de responsabilidade e isenções de garantia estabelecidas nesta seção e em outras partes deste Contrato (coletivamente, as “Limitações”) e que as limitações formam uma base essencial da barganha entre Hyaia e Cliente. As Limitações sobrevivem e se aplicam mesmo se as soluções do Cliente fornecidas neste Contrato falharem em sua finalidade essencial.",
      },
    },
    idemnity_section: {
      title: "Indenização",
      paragraph_1:
        "O Cliente indenizará e isentará a Hyaia e suas afiliadas, funcionários, executivos, diretores, agentes, licenciantes, sucessores e cessionários de todos os danos e responsabilidades, incluindo, sem limitação, os honorários advocatícios incorridos como resultado de:",
      list: {
        item_1: "Violação do Cliente de suas obrigações sob este Contrato;",
        item_2: "Atos negligentes ou intencionais do Cliente;",
        item_3:
          "Pela violação pelo Cliente dos direitos de terceiros relacionados ao uso ou operação do Serviço, incluindo, sem limitação, direitos de privacidade, outros direitos de propriedade, segredo comercial, informações proprietárias, marcas comerciais, direitos autorais ou de patentes, outros direitos de propriedade intelectual e reclamações por difamação, difamação ou práticas comerciais desleais.",
      },
    },
    applicable_law_section: {
      title: "Lei Aplicável",
      paragraph_1:
        "Este contrato é feito com a Hyaia SAS (registrada na França - RCS 503 458 499).",
      paragraph_2:
        "Estes Termos serão regidos pelas leis da França, a menos que expressamente acordado de outra forma, por meio de um Contrato do Cliente.",
      paragraph_3:
        "Pelo presente, concorda expressamente em submeter-se às leis exclusivas da França com o propósito de resolver qualquer disputa relacionada ao seu acesso ou uso do Serviço.",
      paragraph_4:
        "Qualquer dúvida referente aos Termos de Uso deve ser dirigida a support@hyaia.com.",
    },
    aggremment_section: {
      title: "ACORDO PARA ARBITRAR",
      paragraph_1:
        "Antes de apresentar um processo legal formal, primeiro tente entrar em contato com o nosso Suporte ao Cliente, pois a maioria das disputas pode ser resolvida dessa maneira.",
      paragraph_2:
        "Se não pudermos resolver nossa disputa através de nosso Suporte ao Cliente, você ou qualquer uma de suas afiliadas, por um lado, a Hyaia e qualquer uma das afiliadas da Hyaia, concordarão em resolver qualquer disputa decorrente destes Termos ou Notificações de Privacidade, ou em relação aos nossos Serviços por arbitragem obrigatória na França, ou em outro local com o qual ambos concordamos.",
      paragraph_3:
        "Você só pode resolver litígios conosco individualmente e não pode apresentar uma reclamação como um autor ou um membro da classe em uma ação de classe, consolidada ou representativa. Não é permitido arbitragem de classe, ações coletivas, ações particulares de advogados e consolidação com outras arbitragens.",
    },
    original_terms_section: {
      title: "TERMOS DE USO ORIGINAL",
      paragraph_1:
        "Este documento em Português é de livre tradução e não se sobrepõe ao Termo original, usado apenas com finalidade de apoiar o entendimento de nossos clientes. Dúvidas sobre estes Termos devem ser dirigidas ao e-mail support@hyaia.com.",
    },
  },

  mini_navbar: {
    contact_us_nav_text: "Entre em contato",
    partners_nav_text: "PARCEIROS",
    company_nav_text: "EMPRESA",
    contact_nav_text: "CONTATO",
    schedule_demo_text: "Agende uma demo",
  },

  navbar: {
    awards: {
      title: "PREMIAÇÕES",
    },

    examples: {
      title: "EXEMPLOS",
    },

    produtos_menu: {
      title: "PRODUTO",
      connectors: {
        title: "Dados & Conectores",
        conectors_link_text: "Conectores",
        datasources_link_test: "Data Sources",
        datamanagement_link_test: "Gestão de Dados",
        realdata_link_test: "Dados em Tempo Real",
      },
      dashboards_and_reports: {
        title: "Dashboards & Relatórios",
        interactive_dashboard: {
          title: "Dashboards Interativos",
        },
        mobile_dashboards: {
          title: "Dashboards Para Dispositivos Móveis",
        },

        dashboard_design: {
          title: "Dashboards Designer Ágil e Fácil",
        },
      },
      automation: {
        title: "Automação",
        publish_and_share: {
          title: "Publique e Compartilhe",
        },

        scheduling: {
          title: "Agendamento e Alertas",
        },

        security_and_management: {
          title: "Gerenciamento de Usuário",
        },

        advanced_security: {
          title: "Segurança Avançada",
        },
      },
    },

    solutions: {
      title: "SOLUÇÕES",
      sectors: {
        title: "Por Setor",
        retail_text: "Varejo",
        public_sector_text: "Setor Público",
        education_text: "Educação",
        industry_text: "Indústria",
        telecom_text: "Telecom",
        health_text: "Saúde",
        financial_text: "Financeira",
        ecommerce_text: "E-commerce",

        title_2: "Por Dados",
        database_text: "Banco de Dados",
        financials_operational: "Cadeias Financeiras e Operacionais",
      },
    },

    modules: {
      title: "MÓDULOS",
    },

    suport: {
      title: "SUPORTE",
      options: {
        faq_text: "FAQ",
        ticket_text: "Ajuda & Suporte Online",
        chat_text: "Chat Integrado com Nossos Especialistas",
        integrations_text: "API de Integração",
      },
    },
  },

  cookie_consent: {
    section_text_1: `Usamos cookies em nosso site para lhe dar a experiência mais relevante, registrar as suas preferências de visitas. Ao clicar em "Aceitar", você concorda com o uso de TODOS os cookies.`,
    button_text: "ACEITAR",
  },

  request_a_demo: {
    title: "PREENCHA O FORMULÁRIO ABAIXO QUE ENTRAREMOS EM CONTATO:",
    placeholders: {
      name_placeholder_text: "NOME COMPLETO: ",
      email_placeholder_text: "E-MAIL: ",
      phone_placeholder_text: "TELEFONE COM DDD: ",
      company_placeholder_text: "EMPRESA: ",
      comments_placeholder_text: "COMENTÁRIO: ",
    },
    messageSucess: {
      sucess: "Mensagem enviada com sucesso:",
      validation_error_text: "Erro de Validação: Os campos não pode estar em branco"
    }
  },

  footer: {
    change_language: "Trocar Idioma",
    social_media: {
      follow_us_text: "Acompanhe nossas redes sociais:",
    },
    suport_and_services: {
      title: "SERVIÇOS & RECURSOS",
      partners_text: "Parceiros",
      data_connection_text: "Conexão de Dados",
    },
    privacy_and_terms: {
      privacy_policy: "Política de Privacidade",
      terms_of_use: "Termos de Uso",
    },
  },
};

const translation = { translations: PORTUGUESE_TRANSLATION };

export default translation;
